import { Component, OnInit, TemplateRef, ViewChild, OnDestroy, NgZone, Inject, EventEmitter } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { PersonSearchService } from '../_services/person-search.service';
import * as _ from 'underscore';
import { DataService } from '../data.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CandidateService } from '../_services/candidate.service';
import { Subject, Subscription } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { __spreadArrays } from 'tslib';

import { LocalStorageService } from '../_services/local-storage.service';
import { SaveSearchModalComponent } from '../save-search-modal/save-search-modal.component';
import { GlobalService } from '../_services/global.service';
import { AggregationService } from '../_services/aggregation.service';
import { AggReqObjectHandlerService } from '../_services/agg-req-object-handler.service';
import { FilterDataHandlerService } from '../_services/filter-data-handler.service';
import { InsightsDataService } from '../_services/insights-data.service';
import { MatrixFilter } from '../common-interfaces-classes/MatrixFilter';
import { StatsMatrixHandlerService } from '../_services/stats-matrix-handler.service';
import { LoaderType } from '../enums/LoaderType';
import { LoaderEventsService } from '../_services/loader-events.service';
import PersonSearchResponse from '../common-interfaces-classes/PersonSearchResponse';
import { SessionStorageService } from '../_services/session-storage.service';
import { SimilarCandidateService } from '../_services/similar-candidate.service';
import { GeneralConstants } from '../constants/GeneralConstants';
import { FilterParams } from '../common-interfaces-classes/FilterParams';

import { BulkRevealModalComponent } from '../bulk-reveal-modal/bulk-reveal-modal.component';
import { CampaignService } from '../_services/campaign.service';
import { skip } from 'rxjs/operators';
import { DOCUMENT, Location } from '@angular/common';
import { SuggestedTitle } from "../openai/suggested-titles/suggested-titles.component";
import { SimilarCandidateFilterComponent } from '../similar-candidate-filter/similar-candidate-filter.component';
import { JdDataService } from '../jd-data.service';
import { SimilarCandidateDetails } from '../common-interfaces-classes/SimilarCandidate';
import { GenAiJdSearchComponent } from '../gen-ai-jd-search/gen-ai-jd-search.component';
import { JdData } from '../common-interfaces-classes/JdData';

declare var google;
const CONTINENT_MAP = {
  "asia": "142",
  "south america": "005",
  "north america": "021",
  "africa": "002",
  "Oceania": "009"
}

@Component({
  selector: 'app-person-search-listing',
  templateUrl: './person-search-listing.component.html',
  styleUrls: ['./person-search-listing.component.scss']
})
export class PersonSearchListingComponent implements OnInit, OnDestroy {
  searchKeyword: string;
  totalCandidatesCount: number = 0;
  totalMedianTanureCount: number = 0;
  editQuery: boolean = false;
  success_message: string;
  selectable = true;
  removable = true;
  searchtype: any
  addOnBlur: any
  gender: string = 'All';
  /**
   * Flag is set when when any gender is selected except 'ALL'
   */
  isGenderSelected: boolean = false;
  isGenderSelectionDisabled = false;
  contacts: string = 'All';

  seniority: any = [];

  /**
   * Job Title Status Filter for radio button
   */
  jobTitleStatus: string = 'Current';

  /**
   * Job Title Input for autocomplete
   */
  jobTitleInput: FormControl = new FormControl(null);

  /**
   * Job Title List for autocomplete
   */
  jobTitleList: any = [];

  /**
   * Job Title Selected List for autocomplete
   */
  jobTitleSelectedList: any = [];

  jobTitleTopList: any = [];

  locationInput: FormControl = new FormControl(null);

  locationList: any = [];

  locationSelectedList: any = [];

  locationTopList: any = [];


  // current work city
  currentWorkCityInput: FormControl = new FormControl(null);

  currentWorkCityList: any = [];

  currentWorkCitySelectedList: any = [];

  // current work country
  currentWorkCountryInput: FormControl = new FormControl(null);

  currentWorkCountryList: any = [];

  currentWorkCountrySelectedList: any = [];

  // current work locality
  currentWorkLocalityInput: FormControl = new FormControl(null);

  currentWorkLocalityList: any = [];

  currentWorkLocalitySelectedList: any = [];

  // skills
  skillsInput: FormControl = new FormControl(null);

  skillsList: any = [];

  skillsSelectedList: any = [];

  skillsTopList: any = [];

  // company
  companyInput: FormControl = new FormControl(null);

  companyList: any = [];

  companySelectedList: any = [];

  // industry
  industryInput: FormControl = new FormControl(null);

  industryList: any = [];

  industrySelectedList: any = [];

  industryTopList: any = [];

  industryStatus: string = 'Current';

  // field of study
  fieldOfStudyInput: FormControl = new FormControl(null);

  fieldOfStudyList: any = [];

  fieldOfStudySelectedList: any = [];

  fieldOfStudyTopList: any = [];

  // Seniority Level
  seniorityLevelInput: FormControl = new FormControl(null);

  seniorityLevelList: any = [];

  seniorityLevelSelectedList: any = [];

  // education
  educationInput: FormControl = new FormControl(null);

  educationList: any = [];

  educationSelectedList: any = [];

  educationTopList: any = [];
  filterAppliedOnYearsOfGraduation: boolean = false
  filterAppliedOnYearsOfExperience: boolean = false
  filterAppliedOnCurrentYearsOfExperience: boolean = false
  // zip code
  zipCodeInput: FormControl = new FormControl(null);

  zipCodeList: any = [];

  zipCodeSelectedList: any = [];

  // school
  schoolInput: FormControl = new FormControl(null);

  schoolList: any = [];

  schoolSelectedList: any = [];

  schoolTopList: any = [];

  // company size
  companySizeInput: FormControl = new FormControl(null);

  companySizeList: any = [];

  companySizeSelectedList: any = [];

  companysize: any = [];
  /**
  * Flag is set when any company size is selected except 'ALL'
  */
  isCompanySizeSelected: boolean = false

  /**
   * Flag is set when filtered according to contactsAvailability
   */
  contactsAvailabilitySelectedFromInsights: boolean = false
  companyTopList: any = [];

  companyStatus: string = 'Current';

  // graduation year
  graduationYearInput: FormControl = new FormControl(null);

  graduationYearList: any = [];

  graduationYearSelectedList: any = [];

  //salary
  salary: any = 'All';
  isSalarySelected: Boolean = false

  // Likely To Move
  filterLikelyToMoveIn: any = 'All'
  isLikelyToMoveInFilterSelected: Boolean = false
  separatorKeysCodes: number[] = [ENTER, COMMA];

  pageNumber: number = 1;
  pageSize: number = 20;
  currentPage: number = 1;
  start: any = 0; //- start number for pagination (from)
  end: any  = 20//- end number for paginatuin (to)

  isInsightsActive: boolean = false;
  isListingActive: boolean = true;

  candidateList: any[] = [];

  requestObject: any;

  reportsAggs: any = {};
  dataSourceCurrentExperience: any = [];
  dataSourceExpInCurrentRole: any = [];
  dataSourceCurrentIndustry: any = [];
  dataSourcePastIndustry: any = [];
  dataSourceTopLocations: any = [];
  dataSourceCurrentCompany: any = [];
  dataSourceCompany: any = [];
  dataSourceEducation: any = [];
  dataSourceFieldOfStudy: any = [];

  dataSourceFunctions: any = [];
  dataSourceWorkCountry: any = [];
  dataSourcePastCompany: any = [];
  dataSourceSkills: any = [];
  dataSourceCurrentJobTitle: any = [];
  dataSourcePastJobTitle: any = [];
  dataSourceGender: any = [];
  dataSourceSeniority: any = [];
  aggregations: any = [];
  dataSourceYearsOfExperience: any = [];

  dataSourceCurrentYearsOfExperience: any = []
  languageInput: FormControl = new FormControl(null);

  languageList: any = [];

  languageSelectedList: any = [];

  languageTopList: any = [];

  yearsofexperience: any = 'Total';

  yearsofexperienceFrom: FormControl = new FormControl(null);

  yearsofexperienceTo: FormControl = new FormControl(null);




  currentfromyearsofexperience: FormControl = new FormControl(null);
  currenttoyearsofexperience: FormControl = new FormControl(null);

  platformselected: any = 'LinkedIn';

  candidatetoBeGrabbed: any[] = [];

  totalCandidateforTalentpool: any[] = [];

  selected: boolean = false;

  previousTotalCandidateCount: number = 0
  contactsAvailableArray: any[] = [
    { key: 'Personal Email', doc_count: 0 },
    { key: 'Current Professional Email', doc_count: 0 },
    { key: 'Mobile Number', doc_count: 0 },
    { key: 'Social Profiles', doc_count: 0 },
  ];

  contactSelectedList: any[] = [];
  receivedData: any;

  dataSourceYearsOfGraduation: any = null;

  yearsofgraduationFrom: FormControl = new FormControl(null);

  yearsofgraduationTo: FormControl = new FormControl(null);

  profileurlsarray: any = []

  @ViewChild('extractToTalentpool') extractToTalentpool: TemplateRef<any>;

  modalDismissed: Boolean = false;

  talentpoolAndCandidateData: any;
  bulkGrabbingDonePreviously: any;

  @ViewChild('extractingProfile') extractingProfile: TemplateRef<any>;

  @ViewChild('premiumUserError') premiumUserError: TemplateRef<any>;

  successMessage: string;

  errorMessage: string;

  disablebutton: Boolean = true;

  sourceRedirectRef: any;

  bucketName: any;

  showCandidate: boolean = false;

  currentCandidate: any = null;

  bucketbooleanquery: any = null;

  yearsofexperror: any = null;

  yearsofgraderror: any = null;

  likelyToMoveIn: number = 0;

  contactsAvailability: any = null;
  changedJobs: any = null;

  /**Matrix of  Changed Jobs selected or not */
  isChangedJobsSelected:boolean = false;
  /** change Job value i.e yes or no*/
  changedJobStatus: string = 'all';
  /**changed job duration */
  changedJobDuration: number = 12;
  /**changedJobEndDuration */
  changedJobEndDuration: number = 12;
  /**changedJobStartDuration */
  changedJobStartDuration: number = 0;

  /**Male candidate selected in matrix */
  isMaleMatrixSelected: boolean = false;
  /**Female candidate selected in matrix */
  isFemaleMatrixSelected: boolean = false;

  malePercent: any = null;

  femalePercent: any = null;

  experienceError: Boolean = false

  bucketId: any;
  tabType: any = 'profileTab'


  /**
   * Flag is set if any filter applied from above insights
  */
  isFilteredFromInsights: Boolean = false

  /**
    * Flag is set if filter applied from above insights  is candidateslikelytomove
   */
  candidateslikelytomove: String = null
  similarobject: any
  isCalledFromSimilar: boolean = false;

  isOpenAILoading: boolean = true;

  /** Must have fields of similar candidate header */
  mustHaveSimilarCandidate: any[] = [];

  jobTitleTable: MatTableDataSource<any>;

  displayedJobTitleTable: string[] = ['key', 'doc_count'];

  skillsTable: MatTableDataSource<any>;

  displayedSkillsTable: string[] = ['key', 'doc_count'];

  educationTable: MatTableDataSource<any>;
  fieldOfStudyTable: MatTableDataSource<any>;

  topLocationsTable: MatTableDataSource<any>;


  displayedEducationTable: string[] = ['key', 'doc_count'];
  displayedFieldOfStudyTable: string[] = ['key', 'doc_count'];


  displayedTopLocation: string[] = ['key', 'doc_count'];
  talentdiscoveryhistoryid: any;
  currentIndex: any;
  showJobTitleLoader: boolean = false
  showSkillLoader: boolean = false;
  showCompanyLoader: boolean = false;
  showIndustryLoader: boolean = false;
  showFieldOfStudyLoader: boolean = false;
  showEducationLoader: boolean = false;
  showSchoolLoader: boolean = false;
  showLocationLoader: boolean = false;
  showLanguageLoader: boolean = false;
  isLoadingForYearsOfGradFilter: boolean = false;

  minSearchLengthToActivateTypeaheads: number = 3;
  isSimilarCanidate: boolean = false
  similarCanidateFullName: string = ''
  hideSearchBox: boolean = false;
  isCalledFromHistory: boolean = false;
  continentstobeincluded: any[] = [];
  companyInsightsContinents: any[] = [];

  get selectedContinent() {
    switch (this.redirectSource) {
      case 'company-insights':
      // if(this.companyredirectData)
      //     return this.companyredirectData.continentstobeincluded;
      //   else
          return [];
      case 'talent-insights':
        const talentRegion = this.localstorageservice.getItem('talentRegion');
        if (talentRegion) {
          return [talentRegion];
        } else if (this.continentstobeincluded && this.continentstobeincluded.length) {
          return this.continentstobeincluded;
        } else if (this.sessionStorageService.getItem('historyRegion')) {
          return [this.sessionStorageService.getItem('historyRegion')];
        } else {
          return [this.localstorageservice.getItem('region')];
        }
      
      default:
        if (this.sessionStorageService.getItem('historyRegion')) {
          return [this.sessionStorageService.getItem('historyRegion')];
        } else {
          return [this.localstorageservice.getItem('region')];
        }
    }
  }

  get geoIpLocation() {
    const location = JSON.parse(this.localstorageservice.getItem('userGeoIpLocation'));
    const country = location?.country?.toLowerCase();
    const city = location?.city?.toLowerCase();
    const region = location?.region?.toLowerCase();
    const continent = location?.continent?.toLowerCase();
    return { location: `${city || ''}${city && (region || country) ? ', ' : ''}${region || ''}${region && country ? ', ' : ''}${country || ''}`, continent } 
  }

  currentCompanyInformation: any = {}

  isSearchSaved: boolean = false;
  savedSearchDetails: any = null;

  showFunctionsLoader: boolean = false
  linkedInUrlFromSimilarCandidates: any;

  functionsList: any = []
  functionSelectedList: any = []
  functionsInput: FormControl = new FormControl(null)
  seniorityList= GlobalService.seniorityLevels;
  functionTopList: any
  fullnameSelectedList: any[]=[]
  searchedfrom: any;
  highlightkeywords: any
  fullnames: any[] = []

  // Flags for showing individual loaders on person listing tab
  totalCandidatesCountAvailable: boolean = false;
  likelyToMoveInCountAvailable: boolean = false;
  medianTenureInCountAvailable: boolean = false;
  contactsAvailabilityCountAvailable = false;
  genderDataAvailable = false;
  changedJobsCountAvailable = false;



  ChartForCurrentYearsofExperience: any = []
  /**
   * Defines the source from where the user is redirected to this page
   */
  redirectSource: string;
  /**
   * Contains the data of the redirect source
   */
  redirectData: any;
  redirectDataV2: FilterParams;
  /**
   * Redirect Filters
   */
  redirectFilters: any;

  redirectJobTitleFilters: any = [];
  redirectPastJobTitleFilters: any = [];

  redirectSkillsFilters: any = [];

  redirectLocationFilters: any = [];
  quicksearchaidata: any = {};
  insightsaidata: any;
  insightsSubject: Subject<any> = new Subject();

  showregion: string;
  searchHistoryRegion = null;
  @ViewChild('addCandidateToTalentPool') addCandidateToTalentPool: TemplateRef<any>;

  @ViewChild('addCandidateToEmailCampaign') addCandidateToEmailCampaign: TemplateRef<any>;
  selectedCampaign: any;
  campaignList: any;
  campaign_input= new FormControl(null, [Validators.required]);
  emailFoundCount: number;
  showOpenAISuggestions: number;
  searchType: string;
  searchSource: string;
  showLoaderbeforeDataLoad: Boolean = false;
  filterType: string = null;

  aiSuggestion: SuggestedTitle[] = [];
  updateChips: EventEmitter<SuggestedTitle[]> = new EventEmitter<SuggestedTitle[]>();

  public queryForAI: string = "";
  public excludeFromAI: string[] = [];
  get aiQuery() {
    return ([this.searchKeyword].concat([this.queryForAI]).filter(Boolean).join(" OR ")).trim();
  }
  addToTalentpoolSpinner: boolean = false;
  goodToHaveFilters: any[] = [];

  modalFilters = [];

  addToEmailCampaignFromSlider: any[] = [];
  get CompanyLocation() {
    const locations = this.redirectData && this.redirectData.locations ? this.redirectData.locations: [];
    const mandatorylocations = this.redirectData.additionalFilters && this.redirectData.additionalFilters.mandatorylocations ? this.redirectData.additionalFilters.mandatorylocations: [];
    const continents = this.redirectData && this.redirectData.continents ? this.redirectData.continents: [];

    if(locations || mandatorylocations.length || continents.length) {
     return _.uniq(locations.concat(mandatorylocations).concat(continents).map(i => i.replace(/\.searchastext/g,'')));
    }
  }
  

  /**
   * Flag used to disable onclick on add to email campaing when migration is pending
   */
  isLoadingEmailCampaignApi: boolean = false;

  /**
   * Array of candidates selected for email-campaign
   */
  campaignCandidatesArray: any[] = [];
  companyredirectData: any

  viewMoreSkills: boolean = false;

  selectedTitles: SuggestedTitle[] = [];
  
  generateAIMOdalLoader: Boolean = false;
  get getMandatorySkills() {
    const filterData = this.filterDataHandlerService.fetchFilterData;

    let mandatoryskills =[];
    if(this.redirectData?.mandatoryskills) {
      mandatoryskills = this.redirectData.mandatoryskills;
    } if(this.redirectSource == 'company-insights' && this.companyredirectData?.skillsSelectedList.length) {
      mandatoryskills = mandatoryskills.concat(this.companyredirectData.skillsSelectedList.filter(s=>s.isMandatory == true).map(s=>s.key));
    } if(filterData && filterData.skillsSelectedList?.length)
      mandatoryskills = mandatoryskills.concat(filterData.skillsSelectedList.filter(s=>s.isMandatory == true).map(s=>s.key));
    return mandatoryskills;
  }

  constructor(private route: ActivatedRoute, private router: Router, private personSearchService: PersonSearchService, private modalService: NgbModal, private candidateservice: CandidateService, private dataService: DataService,
    private localstorageservice: LocalStorageService,
    private aggregationService: AggregationService, private aggReqObjectHandlerService: AggReqObjectHandlerService,
    private filterDataHandlerService: FilterDataHandlerService,
    private insightsDataService: InsightsDataService,
    private statsMatrixHandlerService: StatsMatrixHandlerService,
    private loaderEventService: LoaderEventsService, private ngZone: NgZone,
    private sessionStorageService: SessionStorageService,
    private similarCandidateService: SimilarCandidateService,
    private emailCampaignService: CampaignService,
    @Inject(DOCUMENT) private document: Document,
    private jdDataService: JdDataService,
    private location: Location
    ) {
      this.searchKeyword = '';

    if (this.jdDataService.isComingFromJobDescription) {
      this.similarobject = {
        data: this.jdDataService.jdDataFromSession
      };
      this.personSearchService.passsimilarcandidatesdata({...this.similarobject});
      this.getsimilarcandidatetooltiptext();
    }
    this.receivedData = this.dataService.getData();
    if (this.receivedData != null && this.receivedData != undefined && this.receivedData.calledFrom == 'advance') {
      console.log("request of adcance", this.receivedData);
      delete this?.receivedData?.requestObject?.fetchtotalpersoncountincontinent;
      Object.keys(this.receivedData.allLists).forEach(x => {
        if (x == 'yearsofgraduationFrom') {
          this.yearsofgraduationFrom.setValue(this.receivedData.allLists[x]);
        } else if (x == 'yearsofgraduationTo') {
          this.yearsofgraduationTo.setValue(this.receivedData.allLists[x]);
        } else if (x == 'yearsofexperienceFrom') {
          this.yearsofexperienceFrom.setValue(this.receivedData.allLists[x])
        } else if (x == 'yearsofexperienceTo') {
          this.yearsofexperienceTo.setValue(this.receivedData.allLists[x])
        }else if(x == 'currentfromyearsofexperience'){
          this.currentfromyearsofexperience.setValue(this.receivedData.allLists[x])
        } else if(x == 'currenttoyearsofexperience') {
          this.currenttoyearsofexperience.setValue(this.receivedData.allLists[x])
        }else {

          this[x] = this.receivedData.allLists[x]

          const keysToRemove = new Set(this.receivedData.allLists.contactSelectedList.map(item => item.key));

          this.receivedData.allLists.contactsAvailableArray = this.receivedData.allLists.contactsAvailableArray.filter(item => !keysToRemove.has(item.key));



        }
      })

      //Add salary range selected
      this.getPersonSearchRecommendedCandidates(this.receivedData.requestObject, true)

    } else if (this.receivedData != null && this.receivedData != undefined && this.receivedData.calledFrom == 'history') {
      this.isCalledFromHistory = true;
      // console.log(this.receivedData.allLists)
      if (this.receivedData?.allLists?.isSimilarCanidate) {
        this.isCalledFromSimilar = true;
        this.similarCandidateService.setListingCalledFromSimilarCandidate(true);
        this.similarobject = this.receivedData.allLists.similarobject;
        this.getsimilarcandidatetooltiptext();
      }
      Object.keys(this.receivedData.allLists).forEach(x => {
        if (x == 'yearsofgraduationFrom') {
          this.yearsofgraduationFrom.setValue(this.receivedData.allLists[x]);
        } else if (x == 'yearsofgraduationTo') {
          this.yearsofgraduationTo.setValue(this.receivedData.allLists[x]);
        } else if (x == 'yearsofexperienceFrom') {
          this.yearsofexperienceFrom.setValue(this.receivedData.allLists[x])
        } else if (x == 'yearsofexperienceTo') {
          this.yearsofexperienceTo.setValue(this.receivedData.allLists[x])
        }else if(x == 'currentfromyearsofexperience'){
          this.currentfromyearsofexperience.setValue(this.receivedData.allLists[x])
        } else if(x == 'currenttoyearsofexperience') {
          this.currenttoyearsofexperience.setValue(this.receivedData.allLists[x])
        }else if(x == 'continentstobeincluded') {
          // this.searchHistoryRegion = this.receivedData.allLists["continentstobeincluded"][0];
          this.sessionStorageService.setItem("historyRegion", this.receivedData.allLists["continentstobeincluded"][0])
        }else if(x == 'companysize') {
          this.companysize = this.receivedData.allLists['companysize']
        }else if(x == 'seniority') {
          this.seniority = this.receivedData.allLists['seniority']
        } else {

          this[x] = this.receivedData.allLists[x]

          // const keysToRemove = new Set(this.receivedData.allLists.contactSelectedList.map(item => item.key));

          // this.receivedData.allLists.contactsAvailableArray = this.receivedData.allLists.contactsAvailableArray.filter(item => !keysToRemove.has(item.key));
        }

        if(x == 'changedjobs'){
          this.changedJobStatus = this.receivedData.allLists[x];
          this.filterDataHandlerService.setChangedJobFilter(this.receivedData.allLists[x]);
        }

        if(x == 'changedjobsstartdurationinmonths'){
          this.changedJobStartDuration = this.receivedData.allLists[x];
        }
        if( x == 'changedjobsenddurationinmonths'){
          this.changedJobEndDuration = this.receivedData.allLists[x];
          this.changedJobDuration = this.receivedData.allLists[x];
        }
        if(x == 'changedjobs' && this.receivedData.allLists[x] == 'yes'){
          this.isChangedJobsSelected = true;
        }
        if(x == 'filterLikelyToMoveIn'){
          this.candidateslikelytomove = this.receivedData.allLists[x];
        }
      })
      setTimeout(() => this.getPersonSearchRecommendedCandidates(this.receivedData.requestObject, true));
    }

    this.isGenderSelected = this.gender && this.gender != 'All' ? true : false;
    this.isCompanySizeSelected = this.companysize && this.companysize.length>0 ? true : false
    // this.filterAppliedOnYearsOfExperience = this.yearsofexperienceFrom.value && this.yearsofexperienceTo.value ? true : false
    let yearFrom = this.yearsofexperienceFrom.value
    let yearTo = this.yearsofexperienceTo.value
    if(yearFrom != null && yearTo != null){
      this.filterAppliedOnYearsOfExperience = yearFrom.toString() && yearTo.toString() ? true : false
    }


    let yearFromCurrent = this.currentfromyearsofexperience.value
    let yearToCurrent = this.currenttoyearsofexperience.value
    if(yearFromCurrent != null && yearToCurrent != null){
      this.filterAppliedOnCurrentYearsOfExperience = yearFromCurrent.toString() && yearToCurrent.toString() ? true : false
    }




    this.linkedInUrlFromSimilarCandidates = this.route.snapshot.queryParams['linkedinurl'];
    if (this.linkedInUrlFromSimilarCandidates) {
      this.similarCandidateService.setListingCalledFromSimilarCandidate(true);
      this.isCalledFromSimilar = true;
    }
    this.filterAppliedOnYearsOfGraduation = this.yearsofgraduationFrom.value && this.yearsofgraduationTo.value ? true : false
    if (this.isCalledFromHistory == false) {
      const ss = this.route.snapshot.queryParams;
      this.searchKeyword = ss['keyword'];
      this.searchedfrom = ss['type'];
      const source = this.route.snapshot.queryParams['redirectSource'];
      this.redirectSource = source;
      this.filterType = this.route.snapshot.queryParams['filtertype'];

      if(this.searchedfrom == 'similar-candidate-from-linkedinurl' || this.searchedfrom == 'view-similar-candidate' || this.searchedfrom == 'similar-candidate-resume-upload' && this.searchedfrom !== GeneralConstants.REDIRECT_SOURCES.JOB_DESCRIPTION) {
        this.isSimilarCanidate = true;
        this.isCalledFromSimilar = true;
        this.similarCandidateService.setListingCalledFromSimilarCandidate(true);
        this.similarobject = JSON.parse(this.localstorageservice.getItem('similar-candidates-additional-filters'));
        this.getsimilarcandidatetooltiptext();
      }

      if(
        (!this.receivedData || this.receivedData.length == 0) &&
        this.redirectSource != 'talent-insights' &&
        this.redirectSource != 'company-insights' &&
        !this.linkedInUrlFromSimilarCandidates &&
        !this.filterType && !this.searchKeyword &&
        !this.isComingFromJD
      ) {
        this.getPersonSearchRecommendedCandidates(null, true)
      }
    }



  }

  subscriptions: Subscription[] = [];

  ngOnInit(): void {
      this.showregion = this.localstorageservice.getItem('region');
    this.personSearchService.getGeoIpLocationOfUser.subscribe((response: any) => {
      this.showregion = this.localstorageservice.getItem('region') ? this.localstorageservice.getItem('region') : response.continent ? response.continent.toLowerCase() : 'asia';
      this.localstorageservice.setItem('region', this.showregion);
    });

      this.route.queryParams.subscribe(params => {
        const searchSource = params['searchSource'];
        if(searchSource == "history-component"){
          this.searchHistoryRegion = this.sessionStorageService.getItem("historyRegion")
        }else{
          this.searchHistoryRegion = null;
        }
      });

    this.insightsDataService.setInsightsActive(false);

    const statsUpdateSub = this.aggregationService.statsUpdateEvent.subscribe(res => this.setMatrixStats(res));
    const changeJobSub = this.aggregationService.changedJobStatsEvent.subscribe(res => this.setChangeJobStats(res));
    this.aggregationService.setResetChangedJob.subscribe(res => {
      this.changedJobEndDuration = 12,
      this.changedJobStartDuration = 0;
      this.changedJobDuration = 12;
      this.changedJobStatus = 'all';
      this.isChangedJobsSelected = false;
      this.isChangedJobsSelected = false;
    })
    this.subscriptions.push(changeJobSub);
    this.subscriptions.push(statsUpdateSub);

    // If recommended candidate API is called from other component/service this event will be emitted
    const recCandidateDataSub = this.aggregationService.recCandidateDataEvent.subscribe(data => this.handleGetPersonSearchAPI(data));
    this.subscriptions.push(recCandidateDataSub);

    // If the stats matrix is updateed through filter component this event will be emitted
    const filterMatrixSub = this.statsMatrixHandlerService.filterMatrixEvent.subscribe(matrixFilter => this.handleMatrixUpdateEvent(matrixFilter));
    this.subscriptions.push(filterMatrixSub);

    // This event makes sure that pagination and similar properties are reset as per changes in filter
    const filterMethodSub = this.filterDataHandlerService.filterMethodEvent.subscribe(filterObj => {
      const excludeFromAITitles = [];
      const collectiveSearchTerm = [];
      const filterData = this.filterDataHandlerService.fetchFilterData;

      if (filterData.jobTitleSelectedList.length) {
        const userSelectedTitle = filterData.jobTitleSelectedList.filter(i => !i.isSuggested).map(i => i.chipkey);
        // @ts-ignore
        collectiveSearchTerm.push(...userSelectedTitle);
        excludeFromAITitles.push(...userSelectedTitle);
      }

      if (filterData.skillsSelectedList.length) {
        const userSelectedSkills = filterData.skillsSelectedList.filter(i => !i.isSuggested).map(i => i.chipkey);
        collectiveSearchTerm.push(...userSelectedSkills);
        excludeFromAITitles.push(...userSelectedSkills);
      }

      const collectiveSearchTermString = collectiveSearchTerm.filter(Boolean).join(" OR ");
      this.queryForAI = collectiveSearchTermString.trim();
      this.excludeFromAI = excludeFromAITitles.filter(Boolean);

      this.resetDataForFilter(filterObj)
    });
    this.subscriptions.push(filterMethodSub);

   const filterData = this.filterDataHandlerService.fetchFilterData;

    const updateTitleSuggestions = filterData.jobTitleSelectedList.filter(jt => jt.isSuggested).map<SuggestedTitle>(js => ({ name: js.chipkey, selected: true, type: 'title', key: this.getSafeKey(js.chipkey) }));
    const updateSkillSuggestions = filterData.skillsSelectedList.filter(jt => jt.isSuggested).map<SuggestedTitle>(js => ({ name: js.chipkey, selected: true, type: 'skill', key: this.getSafeKey(js.chipkey) }));
    
    const aiDataToUpdate = updateTitleSuggestions.concat(updateSkillSuggestions);
    this.selectedTitles = aiDataToUpdate;

    this.updateChips.emit(aiDataToUpdate);

    const aiSuggestionSubscription = this.filterDataHandlerService.fetchAISuggestionData.subscribe(chips => this.updateChipSelection(chips));
    this.subscriptions.push(aiSuggestionSubscription);

    const loaderSub = this.loaderEventService.loaderEvent.subscribe(event => this.setLoaders(event));
    this.subscriptions.push(loaderSub);

    const source = this.route.snapshot.queryParams['redirectSource'];
    this.redirectSource = source;
   // this.redirectData = this.localstorageservice.getItem('talentfilters') ? JSON.parse(this.localstorageservice.getItem('talentfilters')) : null;
    this.redirectSource = this.route.snapshot.queryParams['redirectSource'];
    this.redirectData = this.redirectSource == 'talent-insights' && this.localstorageservice.getItem('talentfilters') ? JSON.parse(this.localstorageservice.getItem('talentfilters')) : this.redirectSource == 'company-insights' && this.localstorageservice.getItem('companyinsightsdetails') ? JSON.parse(this.localstorageservice.getItem('companyinsightsdetails')) : null;
    const redirectDataV2 = this.aggregationService.getTalentInsightsRedirectDataV2();
    this.redirectDataV2 = redirectDataV2;
    const redirectDataMandatory = this.aggregationService.getTalentInsightsMandatoryData();
    if (source === 'talent-insights' && redirectDataV2 && !_.isEmpty(redirectDataV2) && redirectDataMandatory?.additionalFilters) {
      this.redirectData = redirectDataMandatory;
      this.setTalentInsightsRedirectData(redirectDataV2);
      this.checkGenderSelectionFromInsights(redirectDataV2);
      return;
    }

      const companyredirectDataV2 = this.aggregationService.getCompanyInsightsRedirectDataV2();
      this.companyredirectData = companyredirectDataV2;
      const companyRedirectMandatory = this.aggregationService.getCompanyInsightsMandatoryData();

       if (source === 'company-insights' && companyredirectDataV2 && !_.isEmpty(companyredirectDataV2) && companyRedirectMandatory.additionalFilters) {
        this.redirectData = companyRedirectMandatory;
          this.setTalentInsightsRedirectData(companyredirectDataV2);
        return;
       }

   
      if(this.redirectSource == 'talent-insights' && this.redirectData.additionalFilters) {

        this.redirectJobTitleFilters = this.redirectData.jobtitle && this.redirectData.additionalFilters && this.redirectData.additionalFilters.mandatoryjobtitles ? _.uniq(this.redirectData.jobtitle.concat(this.redirectData.additionalFilters.mandatoryjobtitles).map(i => i.replace(/\.searchastext/g, ''))) : this.redirectData.jobtitle ? _.uniq(this.redirectData.jobtitle.map(i => i.replace(/\.searchastext/g, ''))) : this.redirectData.additionalFilters && this.redirectData.additionalFilters.mandatoryjobtitle ? _.uniq(this.redirectData.additionalFilters.mandatoryjobtitle.map(i => i.replace(/\.searchastext/g, ''))) : [];

        this.redirectSkillsFilters = this.redirectData.skills && this.redirectData.additionalFilters && this.redirectData.additionalFilters.mandatoryskills ? _.uniq(this.redirectData.skills.concat(this.redirectData.additionalFilters.mandatoryskills).map(i => i.replace(/\.searchastext/g, ''))) : this.redirectData.skills ? _.uniq(this.redirectData.skills.map(i => i.replace(/\.searchastext/g, ''))) : this.redirectData.additionalFilters && this.redirectData.additionalFilters.mandatoryskills ? _.uniq(this.redirectData.additionalFilters.mandatoryskills.map(i => i.replace(/\.searchastext/g, ''))) : [];

        this.redirectLocationFilters = this.redirectData.location && this.redirectData.additionalFilters && this.redirectData.additionalFilters.mandatorylocations ? _.uniq(this.redirectData.location.concat(this.redirectData.additionalFilters.mandatorylocations).map(i => i.replace(/\.searchastext/g, ''))) : this.redirectData.location ? _.uniq(this.redirectData.location.map(i => i.replace(/\.searchastext/g, ''))) : this.redirectData.additionalFilters && this.redirectData.additionalFilters.mandatorylocations ? _.uniq(this.redirectData.additionalFilters.mandatorylocations.map(i => i.replace(/\.searchastext/g, ''))) : [];

        Object.keys(this.redirectData.additionalFilters).forEach(filter => {
          Object.assign(this.redirectData, { [filter]: this.redirectData.additionalFilters[filter] })
        });
        this.redirectFilters = _.uniq(Object.keys(this.redirectData).filter(key => key != 'additionalFilters' && key != 'totalcount' && key != 'jobtitle' && key != 'location' && key != 'skills' && key != 'mandatoryjobtitles' && key != 'mandatorylocations' && key != 'mandatoryskills' && key != 'recentgraduatesonly' && key != 'recentcompanyhires' && key != 'recentcompanyattrition')
          .reduce((acc, curr) => {
            if (Array.isArray(this.redirectData[curr]) && this.redirectData[curr].length) {
              acc = acc.concat(this.redirectData[curr]);
            } else if (this.redirectData[curr] && !Array.isArray(this.redirectData[curr])) {
              acc = acc.concat(this.redirectData[curr] + ' yrs');
            }
            return acc;
          }, []).map(i => i.replace(/\.searchastext/g, '')));

        this.getPersonSearchRecommendedCandidates(null, true);
        return;
      } 
      // TODO : Handle the redirection source company-insights case
      // else 
      // if (source == 'company-insights' && this.redirectData.additionalFilters) {
      //   this.redirectJobTitleFilters = this.redirectData.additionalFilters && this.redirectData.additionalFilters.mandatoryjobtitles ? _.uniq(this.redirectData.additionalFilters.mandatoryjobtitles.map(i => i.replace(/\.searchastext/g, ''))) : [];

      //   this.redirectSkillsFilters = this.redirectData.skills && this.redirectData.additionalFilters && this.redirectData.additionalFilters.mandatoryskills ? _.uniq(this.redirectData.skills.concat(this.redirectData.additionalFilters.mandatoryskills).map(i => i.replace(/\.searchastext/g, ''))) : this.redirectData.skills ? _.uniq(this.redirectData.skills.map(i => i.replace(/\.searchastext/g, ''))) : this.redirectData.additionalFilters && this.redirectData.additionalFilters.mandatoryskills ? _.uniq(this.redirectData.additionalFilters.mandatoryskills.map(i => i.replace(/\.searchastext/g, ''))) : [];

      //   this.redirectLocationFilters = this.redirectData.locations && this.redirectData.additionalFilters && this.redirectData.additionalFilters.mandatorylocations ? _.uniq(this.redirectData.locations.concat(this.redirectData.additionalFilters.mandatorylocations).map(i => i.replace(/\.searchastext/g, ''))) : this.redirectData.locations ? _.uniq(this.redirectData.locations.map(i => i.replace(/\.searchastext/g, ''))) : this.redirectData.additionalFilters && this.redirectData.additionalFilters.mandatorylocations ? _.uniq(this.redirectData.additionalFilters.mandatorylocations.map(i => i.replace(/\.searchastext/g, ''))) : [];

      //   Object.keys(this.redirectData.additionalFilters).forEach(filter => {
      //     Object.assign(this.redirectData, { [filter]: this.redirectData.additionalFilters[filter] })
      //   });
      //   // this.redirectFilters = _.uniq(Object.keys(this.redirectData).filter(key => key == 'functions' || key == 'mandatoryfunctions' || key == 'mandatoryschools' || key == 'winningtalent' || key == 'losingtalent' || key == 'mandatoryeducationalmajors')
      //   //   .reduce((acc, curr) => {
      //   //     if (Array.isArray(this.redirectData[curr]) && this.redirectData[curr].length) {
      //   //       acc = acc.concat(this.redirectData[curr]);
      //   //     } else if (this.redirectData[curr] && !Array.isArray(this.redirectData[curr])) {
      //   //       acc = acc.concat(this.redirectData[curr] + ' yrs');
      //   //     }
      //   //     return acc;
      //   //   }, []).map(i => i.replace(/\.searchastext/g, '')).concat(this.redirectData.name));

      //   this.getPersonSearchRecommendedCandidates(null, true);
      //   return;
      // }

  

    this.linkedInUrlFromSimilarCandidates = this.route.snapshot.queryParams['linkedinurl'];
    if(this.linkedInUrlFromSimilarCandidates) {
      this.isCalledFromSimilar = true;
      this.isSimilarCanidate = true;
      
      this.similarCandidateService.setListingCalledFromSimilarCandidate(true);
      this.getdetailsFromLinkedin();
      return;
    }

    const ss = this.route.snapshot.queryParams;
    this.searchKeyword = ss['keyword'];
    this.searchType = ss['searchtype']

    this.sourceRedirectRef = ss['source'];
    this.bucketName = ss['bucketName'];
    this.bucketId = ss['bucketId']
    this.searchSource = ss['searchSource']
    if(this.isCalledFromSimilar == false){
      this.searchedfrom = ss['type']
    }


    this.route.queryParams.pipe(skip(1)).subscribe(params => {
      this.searchKeyword = params['keyword'];
      this.searchType = params['searchtype']

      this.sourceRedirectRef = params['source'];
      this.bucketName = params['bucketName'];
      this.bucketId = params['bucketId']
      this.searchSource = params['searchSource']
      if(this.isCalledFromSimilar == false){
        this.searchedfrom = params['type']
      }
      if (this.searchKeyword) {
        if (this.isCalledFromSimilar === false) {
          this.getPersonSearchRecommendedCandidates(null, true);
        }
      }

    });

    this.yearsofexperienceFrom.valueChanges.subscribe(value => {
      // Perform the validation check here
      this.validateYearsOfExperience(value);
    });


    this.yearsofexperienceTo.valueChanges.subscribe(value => {
      // Perform the validation check here
      this.validateYearsOfExperience(value);
    });

    this.currentfromyearsofexperience.valueChanges.subscribe(value => {
      // Perform the validation check here
      this.validateCurrentYearsOfExperience(value);
    });


    this.currenttoyearsofexperience.valueChanges.subscribe(value => {
      // Perform the validation check here
      this.validateCurrentYearsOfExperience(value);
    });

    // validate years of graduation should contain 4 digits only and should be number
    this.yearsofgraduationFrom.valueChanges.subscribe(value => {
      // Perform the validation check here
      this.validateYearsOfGraduation(value);
    });

    this.yearsofgraduationTo.valueChanges.subscribe(value => {
      // Perform the validation check here
      this.validateYearsOfGraduation(value);
    });

    if(this.candidateslikelytomove === 'Yes'){
      this.isLikelyToMoveInFilterSelected = true;
    }
    if(this.changedJobStatus === 'yes'){
      this.isChangedJobsSelected = true;
    }
    if(this.gender === 'Male'){
      this.isMaleMatrixSelected = true;
    }
    if(this.gender === 'Female'){
      this.isFemaleMatrixSelected = true;
    }

    const jdsubscription = this.jdDataService.jdDataEventObs.subscribe(response => this.openSimilarCandidateFilters(response, true));
    this.subscriptions.push(jdsubscription);

    if (this.isComingFromJD) {
      const jdDataFromSession = this.jdDataService.jdDataFromSession;
      jdDataFromSession && this.getPersonSearchRecommendedCandidates();
    }

    const scLoadSub = this.similarCandidateService.scLoaderObs.subscribe(response => {
      this.similarobject = response;
      this.editSimilarCandidateFilters(true);
      // this.isSimilarCanidate = true;
      // this.isCalledFromSimilar = true;
      // this.similarCandidateService.setListingCalledFromSimilarCandidate(true);
      // this.similarobject = JSON.parse(this.localstorageservice.getItem('similar-candidates-additional-filters'));
      // this.getsimilarcandidatetooltiptext();

      // if(this.linkedInUrlFromSimilarCandidates) {
      //   this.getdetailsFromLinkedin();
      //   return;
      // }
    });
    this.subscriptions.push(scLoadSub);
  }

  get isComingFromJD() {
    return this.jdDataService.isComingFromJobDescription;
  }

  /**
   * 
   * This method is specifically used for jd search and on first load or page refresh
   */
  private openSimilarCandidateFilters(jdResponse: JdData, firstLoad = false) {
    const similarobj = firstLoad ? this.jdDataService.getSimilarObj(jdResponse) : this.jdDataService.jdDataFromSession ;
    this.personSearchService.passsimilarcandidatesdata({ data: similarobj, calledfrom: GeneralConstants.REDIRECT_SOURCES.JOB_DESCRIPTION });

    const modalRef = this.modalService.open(SimilarCandidateFilterComponent, { size: 'xl', windowClass: 'modal-size', centered: true, });
    modalRef.componentInstance.disableDisableButton = firstLoad;
    modalRef.result.then((res) => {
      if (res.action == 'submit') {
        this.personSearchService.passsimilarcandidatesdata(res);
        const uniqueHash = this.route.snapshot.queryParamMap.get(GeneralConstants.LS_KEYS.UNIQUE_HASH);
        this.similarobject = res.data ? res.data : new SimilarCandidateDetails();
        this.jdDataService.setSessionData(uniqueHash, this.similarobject);
        this.getsimilarcandidatetooltiptext();
        this.resetMustAndGoodFilters();
        this.jdDataService.jdFilterUpdateEventEmit();
      } else if (res.action === 'close' && firstLoad) {
        this.location.back();
      }
    });
  }

  private checkGenderSelectionFromInsights(redirectDataTI: FilterParams) {
    // TODO : May need to handle same for company insights as well later
    if (this.redirectSource === 'talent-insights' && ["male", "female"].includes(redirectDataTI.gender?.toLowerCase())) {
      this.gender = redirectDataTI.gender;
      this.isGenderSelected = true;
      this.isGenderSelectionDisabled = true;
      if (redirectDataTI.gender.toLowerCase() === 'male') {
        this.isMaleMatrixSelected = true;
        this.isFemaleMatrixSelected = false;
      }
      else if (redirectDataTI.gender.toLowerCase() === 'female') {
        this.isFemaleMatrixSelected = true;
        this.isMaleMatrixSelected = false;
      }
    }
  }

  private setTalentInsightsRedirectData(redirectDataV2: FilterParams) {
    this.redirectJobTitleFilters = this.getSanitizedJobTitles(redirectDataV2);
    this.redirectPastJobTitleFilters = this.getSanitizedPastJobTitles(redirectDataV2);
    this.redirectSkillsFilters = this.getSanitizedSkills(redirectDataV2);
    this.redirectLocationFilters = this.getSanitizedLocations(redirectDataV2);
    const appliedFilters = this.redirectSource == 'talent-insights' ? this.getAppliedFilters(redirectDataV2): this.getCompanyInsightsFilters(redirectDataV2);
    const mandatoryFilters = this.redirectSource == 'talent-insights' ? this.getMandatoryFields(): this.getCompanyInsightsFields();
    // Combine and deduplicate the arrays based on name and value
    const combinedFilters = appliedFilters.concat(mandatoryFilters);    
    const uniqueFilters = combinedFilters.reduce((acc, current) => {
      const exists = acc.some(item => item.value === current.value);
      // const exists = acc.some(item => item.name === current.name && item.value === current.value);
      if (!exists) {
        acc.push(current);
      }
      return acc;
    }, []);

    // Filter out elements with name or value equal to "all"
    this.redirectFilters = uniqueFilters
      .filter(el => el?.value?.trim().toLowerCase() !== "all");
    this.getPersonSearchRecommendedCandidates(null, true);
  }

  private getMandatoryFields() {
    Object.keys(this.redirectData.additionalFilters).forEach(filter => {
      Object.assign(this.redirectData, { [filter]: this.redirectData.additionalFilters[filter] });
    });
    const excludedKeys = new Set([
      'additionalFilters', 'totalcount', 'mandatoryjobtitles', 'mandatorylocations', 'mandatoryskills',
      'recentgraduatesonly', 'recentcompanyhires', 'recentcompanyattrition', 'winningtalent', 'loosingtalent', 'mandatoryschools'
    ]);
    const mandatoryFilters = _.uniq(
      Object.keys(this.redirectData)
        .filter(key => !excludedKeys.has(key))
        .reduce((acc, curr) => {
          if (Array.isArray(this.redirectData[curr]) && this.redirectData[curr].length) {
            this.redirectData[curr].forEach(el => {
              acc = acc.concat({ name: GeneralConstants.HOVER_MANDATORY_FILTER_NAME_MAP[curr], value: el });
            });
          } else if (this.redirectData[curr] && !Array.isArray(this.redirectData[curr])) {
            acc = acc.concat({ name: GeneralConstants.HOVER_MANDATORY_FILTER_NAME_MAP[curr], value: this.redirectData[curr] + ' yrs' });
          }
          return acc;
        }, []).map(obj => ({ name: obj.name.replace(/\.searchastext/g, ''), value: obj.value }))
    );
    return mandatoryFilters;
  }

  private getAppliedFilters(redirectDataV2: FilterParams) {

    const filterNameKey = new Set([
      'companySelectedList', 'companysize', 'industrySelectedList', 'functionSelectedList',
      'seniority', 'yearsofexperienceFrom', 'currentfromyearsofexperience',
      'gender', 'educationSelectedList', 'schoolSelectedList', 'fieldOfStudySelectedList', 'keywordSelectedList'
    ]);

    const appliedFilters = [];
    filterNameKey.forEach(key => {
      let filterText;
      if (key === 'yearsofexperienceFrom' && redirectDataV2?.yearsofexperienceFrom && redirectDataV2?.yearsofexperienceTo) {
        filterText = redirectDataV2?.yearsofexperienceFrom + ' to ' + redirectDataV2?.yearsofexperienceTo + ' yrs.';
      } else if (key === 'gender') {
        filterText = redirectDataV2?.isGenderSelected ? redirectDataV2[key] : "";
      } else if (key === 'currentfromyearsofexperience' && redirectDataV2?.currentfromyearsofexperience && redirectDataV2?.currenttoyearsofexperience) {
        filterText = redirectDataV2?.currentfromyearsofexperience + ' to ' + redirectDataV2?.currenttoyearsofexperience + ' yrs.';
      } else if (Array.isArray(redirectDataV2[key])) {
        redirectDataV2[key].forEach(el => {
          if (typeof el === "object" && !el?.isExcluded) appliedFilters.push({name : [GeneralConstants.HOVER_FILTER_NAME_MAP[key]], value: el?.chipkey});
          else if (typeof el === "string") appliedFilters.push({name : [GeneralConstants.HOVER_FILTER_NAME_MAP[key]], value: el});
        });
      } else {
        filterText = redirectDataV2[key];
      }
      typeof filterText === "string" && filterText.length && appliedFilters.push({name : [GeneralConstants.HOVER_FILTER_NAME_MAP[key]], value: filterText});
      appliedFilters.push({name: ['Company'], value: this.redirectData.name})
    });
    return appliedFilters?.filter(el => !!el?.value);
  }

  private getSanitizedPastJobTitles(redirectDataV2: FilterParams) {
    const pastJobTitles = redirectDataV2.pastJobTitleSelectedList?.filter(el => !el.isExcluded)?.map(el => el?.chipkey) || [];
    const sanitizedPastJobTitles = _.uniq(
      pastJobTitles.map(i => i.replace(/\.searchastext/g, ''))
    );
    return sanitizedPastJobTitles;
  }

  private getCompanyInsightsFilters(redirectDataV2: FilterParams) {
    const filterNameKey = new Set([
      'companySelectedList', 'companysize', 'industrySelectedList', 'functionSelectedList', 
      'seniority', 'yearsofexperienceFrom', 'currentfromyearsofexperience', 
      'gender', 'educationSelectedList', 'schoolSelectedList', 'fieldOfStudySelectedList', 'keywordSelectedList', 
      'recentcompanyhires', 'recentcompanyattrition', 'winningtalent', 'loosingtalent', 'continentstobeincluded'
    ]);

    const appliedFilters = [];
    filterNameKey.forEach(key => {
      let filterText;
      if (key === 'yearsofexperienceFrom' && redirectDataV2?.yearsofexperienceFrom && redirectDataV2?.yearsofexperienceTo) {
        filterText = redirectDataV2?.yearsofexperienceFrom + ' to ' + redirectDataV2?.yearsofexperienceTo + ' yrs.';
      } else if (key === 'gender') {
        filterText = redirectDataV2?.isGenderSelected ? redirectDataV2[key] : "";
      } else if (key === 'currentfromyearsofexperience' && redirectDataV2?.currentfromyearsofexperience && redirectDataV2?.currenttoyearsofexperience) {
        filterText = redirectDataV2?.currentfromyearsofexperience + ' to ' + redirectDataV2?.currenttoyearsofexperience + ' yrs.';
      } else if (Array.isArray(redirectDataV2[key])) {
        redirectDataV2[key].forEach(el => {
          if (typeof el === "object" && !el?.isExcluded) appliedFilters.push({name : [GeneralConstants.HOVER_FILTER_NAME_MAP[key]], value: el?.chipkey});
          else if (typeof el === "string") appliedFilters.push({name : [GeneralConstants.HOVER_FILTER_NAME_MAP[key]], value: el});
        });
      } else {
        filterText = redirectDataV2[key];
      }
      typeof filterText === "string" && filterText.length && appliedFilters.push({name : [GeneralConstants.HOVER_FILTER_NAME_MAP[key]], value: filterText});
      appliedFilters.push({name: ['Company'], value: this.redirectData.name})
    });
    return appliedFilters?.filter(el => !!el?.value);
  }

  private getSanitizedLocations(redirectDataV2: FilterParams) {
    const baseLocations = redirectDataV2.locationSelectedList?.filter(el => !el.isExcluded)?.map(el => el?.chipkey) || [];
    const additionalLocations = this.redirectData?.additionalFilters?.mandatorylocations
      ? this.redirectData.additionalFilters.mandatorylocations
      : this.redirectData?.additionalFilters?.mandatorylocation
        ? this.redirectData.additionalFilters.mandatorylocation
        : [];
    const sanitizedLocations = _.uniq(
      baseLocations?.concat(additionalLocations)
        .map(location => location?.replace(/\.searchastext/g, ''))
    );
    return sanitizedLocations?.filter(Boolean);
  }

  private getSanitizedSkills(redirectDataV2: FilterParams) {
    const baseSkills = redirectDataV2.skillsSelectedList?.map(el => el?.chipkey) || [];
    const additionalSkills = this.redirectData?.additionalFilters?.mandatoryskills
      ? this.redirectData.additionalFilters.mandatoryskills
      : this.redirectData?.additionalFilters?.mandatoryskill
        ? this.redirectData.additionalFilters.mandatoryskill
        : [];
    const sanitizedSkills = _.uniq(
      baseSkills.concat(additionalSkills)
        .map(skill => skill.replace(/\.searchastext/g, ''))
    );
    return sanitizedSkills;
  }

  private getSanitizedJobTitles(redirectDataV2: FilterParams) {
    const jobTitles = redirectDataV2.jobTitleSelectedList?.filter(el => !el.isExcluded)?.map(el => el?.chipkey) || [];
    const additionalJobTitles = this.redirectData?.additionalFilters?.mandatoryjobtitles
      ? this.redirectData.additionalFilters.mandatoryjobtitles
      : this.redirectData?.additionalFilters?.mandatoryjobtitle
        ? this.redirectData.additionalFilters.mandatoryjobtitle
        : [];
    const sanitizedJobTitles = _.uniq(
      jobTitles.concat(additionalJobTitles)
        .map(i => i.replace(/\.searchastext/g, ''))
    );
    return sanitizedJobTitles;
  }

  private getCompanyInsightsFields() {
    Object.keys(this.redirectData.additionalFilters).forEach(filter => {
      Object.assign(this.redirectData, { [filter]: this.redirectData.additionalFilters[filter] });
    });
    const excludedKeys = new Set([
      'additionalFilters', 'totalcount', 'mandatoryjobtitles', 'mandatorylocations', 'mandatoryskills',
      'recentgraduatesonly', 'recentcompanyhires', 'recentcompanyattrition', 'name','alternative_names'
    ]);
    const mandatoryFilters = _.uniq(
      Object.keys(this.redirectData)
        .filter(key => !excludedKeys.has(key))
        .reduce((acc, curr) => {
          if (Array.isArray(this.redirectData[curr]) && this.redirectData[curr].length) {
            this.redirectData[curr].forEach(el => {
              acc = acc.concat({ name: GeneralConstants.HOVER_MANDATORY_COMPANYFILTER_NAME_MAP[curr], value: el });
            });
          } else if (this.redirectData[curr] && !Array.isArray(this.redirectData[curr])) {
            acc = acc.concat({ name: GeneralConstants.HOVER_MANDATORY_COMPANYFILTER_NAME_MAP[curr], value: this.redirectData[curr] + ' yrs' });
          }
          return acc;
        }, []).map(obj => ({ name: obj.name.replace(/\.searchastext/g, ''), value: obj.value }))
    );
    return mandatoryFilters;
  }

  ngOnDestroy(): void {
    for (let sub of this.subscriptions) { sub.unsubscribe(); }
    this.similarCandidateService.setListingCalledFromSimilarCandidate(false);
    this.aggReqObjectHandlerService.setShareRequestObject({});
  }

  private handleGetPersonSearchAPI(data: PersonSearchResponse) {
    this.isSearchSaved = false;
    this.talentdiscoveryhistoryid = data.talentdiscoveryhistoryid;
    this.filterDataHandlerService.setTalentDiscoveryHistoryID(data.talentdiscoveryhistoryid);
    this.getSavedSearchDetails();
    if (!this.isFilteredFromInsights) { this.previousTotalCandidateCount = data.totalresultscount; }
    // if (this.searchKeyword) {
    //   this.highlightkeywords = this.searchKeyword.split(" ");
    //   this.highlightkeywords = this.highlightkeywords.filter(x=>(x != ('AND' || 'and') && x!= ('OR' || 'or') && x!=('NOT' || 'not') && x!= '*'));
    //   this.highlightkeywords = this.highlightkeywords.filter(x=>x.replace(/()*"/g, ''));
    // }
    this.totalCandidatesCount = data.totalresultscount;
    this.totalCandidatesCountAvailable = true;
    if (this.totalCandidatesCount < 20) { this.end = this.totalCandidatesCount; }
    this.candidateList = data.candidateList;
    this.aggregationService.getStatsAggs();
    this.isInsightsActive && this.aggregationService.getTotalAggs();
    if (data.booleanquery) { this.bucketbooleanquery = data.booleanquery; }
    this.showLoaderbeforeDataLoad = false;
    this.selected = false;
  }

  private setLoaders(event: LoaderType) {
    if (event === LoaderType.RECOMMENDED_CANDIDATE) {
      this.totalCandidatesCountAvailable = false;
      this.showLoaderbeforeDataLoad = true;
      this.turnOnLoaders();
    } else if (event === LoaderType.STATS) {
      this.turnOnLoaders();
    }
  }

  private resetDataForFilter(filterObj: {methodName: string}) {
    if (
      [
        "clearfilters", "selectedItem", "filterByStatus",
        "addToSelectedList", "removeChip", "applyFilter", "mandatoryFilterItem", "excludeFilterItem", "changeContinent", "searchInput"
      ].map(el => el.toLowerCase()).includes(filterObj.methodName?.trim().toLowerCase())
    ) {
      this.resetPagination();
    }
    if (
      [
        "selectedItem", "filterByStatus", "excludeFilterItem",
        "addToSelectedList", "removeChip", "mandatoryFilterItem", "changeContinent", "searchInput"
      ].map(el => el.toLowerCase()).includes(filterObj.methodName?.trim().toLowerCase())
    ) {
      this.isFilteredFromInsights = false;
      this.contactsAvailabilitySelectedFromInsights = false;
    }
    if (
      [
        "removeChip"
      ].map(el => el.toLowerCase()).includes(filterObj.methodName?.trim().toLowerCase())
    ) {
      this.candidateslikelytomove = null;
    }
    this.aggReqObjectHandlerService.setStartIndex(0);
  }

  private handleMatrixUpdateEvent(matrixFilter: MatrixFilter) {
    if (matrixFilter.type === 'gender' && matrixFilter.event?.target?.value === "All") {
      this.isMaleMatrixSelected = false;
      this.isFemaleMatrixSelected = false;
    }
    else if (matrixFilter.type === 'gender' && matrixFilter.event?.target?.value === "Male") {
      this.isMaleMatrixSelected = true;
      this.isFemaleMatrixSelected = false;
    }
    else if (matrixFilter.type === 'gender' && matrixFilter.event?.target?.value === "Female") {
      this.isFemaleMatrixSelected = true;
      this.isMaleMatrixSelected = false;
    }
    else if (matrixFilter.type === 'likelytomovein') {
      this.isLikelyToMoveInFilterSelected = matrixFilter?.event?.target?.value === "Yes";
    }
    // No need to work on this since we don't have this option in filters
    // else if (matrixFilter.type === 'changedJobs') {
    //   this.isChangedJobsSelected = !this.isChangedJobsSelected;
    // }
  }

  private setCountAvailableAll() {
    this.likelyToMoveInCountAvailable = true;
    this.medianTenureInCountAvailable = true;
    this.genderDataAvailable = true;
    this.changedJobsCountAvailable = true;
  }

  getdetailsFromLinkedin() {
    this.personSearchService.getdetailsfromlinkedin(this.linkedInUrlFromSimilarCandidates).subscribe((res:any)=>{
      if(res.status == "success") {
        if(res.data) {
          const pastindustries = _.pluck(res.data.experience, 'company')
          const schools = _.pluck(res.data.education, 'school')
          const locations = []
          res.data.location_locality && locations.push(res.data.location_locality);
          res.data.location_region && locations.push(res.data.location_region);
          res.data.location_country && locations.push(res.data.location_country);

          const totalTenure = res.data.totaltenure || 0;  
          const fromYrsOfExperience = (parseInt(totalTenure) - (parseInt(totalTenure) * 0.25));
          const toYrsOfExperinece = (parseInt(totalTenure) + (parseInt(totalTenure) * 0.25));
        
          this.similarobject = {
            data: {
              jobtitle: res.data.job_title ? [{ key: res.data.job_title, isMandatory: true }] : [],
              jobcompanyname: res.data.job_company_name ? [{ key: res.data.job_company_name, isMandatory: false }] : [],
              jobindustryname: res.data.job_company_industry ? [{ key: res.data.job_company_industry, isMandatory: true }] : [],
              pastindustries: _.pluck(pastindustries, 'industry'),
              schools: _.pluck(schools, 'name'),
              currentlocation: _.uniq(locations).map(l => ({ key: l, isMandatory: false })),
              skills: res.data.skills ? res.data.skills.map(s => ({ key: s, isMandatory: false })) : [],
              elasticid: res.data.id,
              companysize: res.data.job_company_size ? [{ key: res.data.job_company_size, isMandatory: false }] : [],
              fullname: res.data.full_name,
              linkedinurl: this.linkedInUrlFromSimilarCandidates,
              isUploadedFromResume: false,
              locationregion: res.data.location_region,
              locationcontinent: res.data.location_continent,
              totaltenure: totalTenure,
              fromYrsOfExperience,
              toYrsOfExperinece
            }
  
          }
          this.getsimilarcandidatetooltiptext();
          this.personSearchService.passsimilarcandidatesdata({ ...this.similarobject})
          this.getPersonSearchRecommendedCandidates(null, true);
        } else if(res.message == 'Person not found') {
          // this.linkedinerrormsg = 'Sorry, for some reason we were unable to find this LinkedIn profile.'
        }
      }
    })

  }

  viewmoredetails(type, data) {
    if (type == 'viewmore' && data == 'currentcompany') {
      document.getElementById('top1').style.display = 'none'
      document.getElementById('top2').style.display = 'block'
      document.getElementById('viewmore1').style.display = 'none'
      document.getElementById('viewless2').style.display = 'block'
    } else if (type == 'viewless' && data == 'currentcompany') {
      document.getElementById('top1').style.display = 'block'
      document.getElementById('top2').style.display = 'none'
      document.getElementById('viewmore1').style.display = 'block'
      document.getElementById('viewless2').style.display = 'none'
    }
    if (type == 'viewmore' && data == 'currentIndustry') {
      document.getElementById('top3').style.display = 'none'
      document.getElementById('top4').style.display = 'block'
      document.getElementById('viewmore3').style.display = 'none'
      document.getElementById('viewless4').style.display = 'block'
    } else if (type == 'viewless' && data == 'currentIndustry') {
      document.getElementById('top3').style.display = 'block'
      document.getElementById('top4').style.display = 'none'
      document.getElementById('viewmore3').style.display = 'block'
      document.getElementById('viewless4').style.display = 'none'
    }
    if(type == 'viewMore' && data == 'similar-candidate'){
      document.getElementById('similarCandidate-viewMore').style.display = 'none';
      document.getElementById('similarCandidate-viewLess').style.display = 'block';
    }else if(type == 'viewLess' && data == 'similar-candidate'){
      document.getElementById('similarCandidate-viewMore').style.display = 'block';
      document.getElementById('similarCandidate-viewLess').style.display = 'none';
    }

    if(type == 'viewMore' && data == 'similar-candidate-must-have'){
      document.getElementById('similarCandidate-viewMore-must-have').style.display = 'none';
      document.getElementById('similarCandidate-viewLess-must-have').style.display = 'block';
    }else if(type == 'viewLess' && data == 'similar-candidate-must-have'){
      document.getElementById('similarCandidate-viewMore-must-have').style.display = 'block';
      document.getElementById('similarCandidate-viewLess-must-have').style.display = 'none';
    }

    if(type == 'viewMore' && data == 'modal-ms'){
      document.getElementById('modal-viewMore').style.display = 'none';
      document.getElementById('modal-viewLess').style.display = 'block';
    }else if(type == 'viewLess' && data == 'modal-ms'){
      document.getElementById('modal-viewMore').style.display = 'block';
      document.getElementById('modal-viewLess').style.display = 'none';
    }

    if (data === 'talent-insights-filters' && type === 'viewMore') {
      document.getElementById('TIViewMore').style.setProperty('display', 'flex', 'important');
      document.getElementById('TIViewLess').style.setProperty('display', 'none', 'important');
    } else if (data === 'talent-insights-filters' && type === 'viewLess') {
        document.getElementById('TIViewMore').style.setProperty('display', 'none', 'important');
        document.getElementById('TIViewLess').style.setProperty('display', 'flex', 'important');
    }

  }

  viewMoreSimilarCandidate(type){

  }
  private validateYearsOfGraduation(value: number | string) {
    const fromGraduation = parseInt(this.yearsofgraduationFrom.value, 10) || null;
    const toGraduation = parseInt(this.yearsofgraduationTo.value, 10) || null;
    if (Number.isInteger(fromGraduation) && Number.isInteger(toGraduation)) {
      // check if fromgraduation is 4 digits
      if (fromGraduation.toString().length != 4 || toGraduation.toString().length != 4) {
        return this.yearsofgraduationFrom.setErrors({ 'invalidYears': true });
      }
      if (fromGraduation >= toGraduation && this.yearsofgraduationTo.value != null && this.yearsofgraduationFrom.value != null) {
        this.yearsofgraduationFrom.setErrors({ 'invalidYears': true });
      } else {
        this.yearsofgraduationFrom.setErrors(null);
      }
    }
  }

  private getFormattedTenure(tenure: number) {
    const totalYears = Math.floor(tenure);
    const totalMonths = Math.round((tenure - totalYears) * 12);
    if (totalYears > 0 && totalMonths > 0) {
      return `${totalYears} ${totalYears == 1 ? 'Yr' : 'Yrs'} ${totalMonths} Mths`;
    } else if (totalYears > 0 && totalMonths == 0) {
      return `${totalYears} ${totalYears == 1 ? 'Yr' : 'Yrs'}`;
    } else if (totalYears == 0 && totalMonths > 0) {
      return `${totalMonths} Mths`;
    } else {
      return '';
    }
  }

  
 returnSpanTag(text) {
  let spanTag = document.createElement("span");
  spanTag.className='median-tenure-text-size';
  spanTag.innerHTML = text
  return spanTag;
}

getFormattedTenureForMatrix(tenure: number) {
  const totalYears = Math.floor(tenure);
  const totalMonths = Math.round((tenure - totalYears) * 12);
  if(tenure == null){
    return 0;
  }else if (totalYears > 0 && totalMonths > 0) {
    if(totalMonths == 12) {
      return `${totalYears + 1} ${totalYears == 1 ? this.returnSpanTag('Yr').outerHTML.toString() : this.returnSpanTag('Yrs').outerHTML.toString()}`;
    } else {
      return `${totalYears} ${totalYears == 1 ? this.returnSpanTag('Yr').outerHTML.toString() : this.returnSpanTag('Yrs').outerHTML.toString()} ${totalMonths} ${this.returnSpanTag('Mths').outerHTML.toString()}`;
    }
  } else if (totalYears > 0 && totalMonths == 0) {
    return `${totalYears} ${totalYears == 1 ? this.returnSpanTag('Yr').outerHTML.toString() : this.returnSpanTag('Yrs').outerHTML.toString()}`;
  } else if (totalYears == 0 && totalMonths > 0) {
    if(totalMonths == 12) {
      return `${totalYears + 1} ${this.returnSpanTag('Yr').outerHTML.toString()}`;
    } else
    return `${totalMonths} ${this.returnSpanTag('Mths').outerHTML.toString()}`;
  } else {
    return '';
  }
}

  validateYearsOfExperience(value: number | string) {
    const fromExperience = parseInt(this.yearsofexperienceFrom.value, 10);
    const toExperience = parseInt(this.yearsofexperienceTo.value, 10);

    if (Number.isInteger(fromExperience) && Number.isInteger(toExperience)) {
      if (fromExperience >= toExperience && this.yearsofexperienceTo.value != null && this.yearsofexperienceFrom.value != null) {
        this.yearsofexperienceFrom.setErrors({ 'invalidYears': true });
      } else if(toExperience > 40){
        this.yearsofexperienceFrom.setErrors({ 'toohigh': true });
      }else if(fromExperience < 1){
        this.yearsofexperienceFrom.setErrors({ 'toolow': true });
      }else {
        this.yearsofexperienceFrom.setErrors(null);
      }
    }
  }

  validateCurrentYearsOfExperience(value: number | string) {
    const fromExperience = parseInt(this.currentfromyearsofexperience.value, 10);
    const toExperience = parseInt(this.currenttoyearsofexperience.value, 10);

    if (Number.isInteger(fromExperience) && Number.isInteger(toExperience)) {
      if (fromExperience >= toExperience && this.currenttoyearsofexperience.value != null && this.currentfromyearsofexperience.value != null) {
        this.currentfromyearsofexperience.setErrors({ 'invalidYears': true });
      } else if(toExperience > 40){
        this.currentfromyearsofexperience.setErrors({ 'toohigh': true });
      }else if(fromExperience < 1){
        this.currentfromyearsofexperience.setErrors({ 'toolow': true });
      }else {
        this.currentfromyearsofexperience.setErrors(null);
      }
    }

  }


  /**
    * Handles child events and accordingly calls specified function
    * @param event childevent
    */
  eventHandler(event) {
    setTimeout(() => {
      if(event && event.data && event.data.currentIndex >=0){
        event.data.lastseencount = 1;
        this.candidateList[event.data.currentIndex].lastseencount = 1
      }
    },1000)

    var val = event.data.idinindex
    this.candidateList.find(function (item, i) {
      if (item.idinindex === val) {
        index = i;
        return i;
      }
    });

    var index = -1;

    if (event.action == 'append-data' && event.data != undefined && typeof event.data == 'object') {
      // this.candidateList[event.data.currentIndex] = event.data

      var val = event.data.idinindex
      this.candidateList.find(function (item, i) {
        if (item.idinindex === val) {
          index = i;
          return i;
        }
      });

      if(event.data && event.data.existingContactDetails){
        this.candidateList[index]['existingContactDetails'] = event.data.existingContactDetails;
        this.candidateList[index]['candidatenumber'] = event.data.candidatenumber;
        this.candidateList[index] = Object.assign([], this.candidateList[index]);

      }
       if(event.data && event.data.iswebbtreeverified){
        this.candidateList[index]['iswebbtreeverified'] = 1;
      }

      if(event.data && event.data.usedWebbtreeIntroduction){
        this.candidateList[index]['usedWebbtreeIntroduction'] = 1;
      }
    }

    const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');

    if (event.action == 'openNav') {
      //loadn[0].style.display = 'none'
      if (event.type == 'show-contact') {
        this.tabType = 'contactTab'
      } else if(event.type == 'show-activity') {
        this.tabType = 'activityTab'
      } else if(event.type == 'show-skills') {
        this.tabType = 'profileTab'
        this.viewMoreSkills = true;
      }
      else{
        this.tabType = 'profileTab'
      }

      if(event.data && event.data.experience && event.data.experience.length){
        const companyObjects = _.pluck(event.data.experience, 'company');
        const companyNames = _.unique(_.pluck(companyObjects, 'name'));
        const filteredCompanyNames = _.filter(companyNames, (name) => {
          return name !== null && name !== undefined && name !== '';
        });

        let nameData = {
          companynames: filteredCompanyNames
        }
        this.personSearchService.getCompanyLogo(nameData).subscribe((res: any) => {
          if(res && res.status == "success"){
            const resultName = res.message
            resultName.forEach(obj => {
              const matchingObj = event.data.experience.filter((item) => (item.company && item.company.name) === obj.key);
              if (matchingObj && matchingObj.length) {
                let companyLogo = obj.companylogo
                matchingObj.forEach(x => {
                  x.companylogo = companyLogo;
                })

              }
            });

            this.openCandidateSlider(index == -1 ? event.data: this.candidateList[index], event.currentIndex)
          }else{
            this.openCandidateSlider(index == -1 ? event.data: this.candidateList[index], event.currentIndex)
          }
        });
      }else{
        this.openCandidateSlider(index == -1 ? event.data: this.candidateList[index], event.currentIndex)
        //loadn[0].style.display = 'none'
      }



    } else if (event.action == 'closeNav') {
      this.closeNav();
    }

    this.getLastActivity(event.data.idinindex)
  }

  openCandidateSlider(data, currentIndex) {
    this.currentCandidate = data;
    this.currentIndex = currentIndex
    this.showCandidate = true;
    document.getElementById("quickView").style.width = "55%";
    document.getElementById("quickView").style.right = "0";
    document.getElementById("overlay").style.display = "block";
    const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
    //loadn[0].style.display = 'none'
  }

  closeNav() {
    this.viewMoreSkills = false;
    this.showCandidate = false
    document.getElementById("quickView").style.width = "0";
    document.getElementById("overlay").style.display = "none";
    document.getElementById("quickView").style.right = "-50px";
    const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
    //loadn[0].style.display = 'block'
  }

  convertToHTML(data: string) {
    if(!data) return '';
    // replace boolean string AND OR NOT with html tags
    data = data.replace(/AND/g, '<span class="text-webbtree-green">AND</span>');
    data = data.replace(/OR/g, '<span class="text-webbtree-green">OR</span>');
    data = data.replace(/NOT/g, '<span class="text-webbtree-green">NOT</span>');
    return data;
  }

  copySearchQuery() {
    let dummy = document.createElement("textarea");
    document.body.appendChild(dummy);
    dummy.value = this.searchKeyword;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
    this.success_message = "Boolean string copied succesfully"
    setTimeout(() => this.success_message = '', 5000);
  }

  search() {
    if (this.searchKeyword) {
      // if(this.searchSource && this.searchSource == 'history-component') {
      //   this.getPersonSearchRecommendedCandidates(null, true)
      // } else {
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: {
            bucketName: null,
            source: null,
            keyword: this.searchKeyword
          },
          queryParamsHandling: 'merge',
        });
        this.bucketName = null;
        this.sourceRedirectRef = null;
        this.bucketbooleanquery = null;
        this.resetPagination();
      }
    //}
  }

  private resetPagination() {
    this.start = 0;
    this.currentPage = 1;
    this.end = 20;
  }

  /**Get "booleanquery" key for  "getPersonSearchRecommendedCandidates" request body*/
  getBooleanQuery() {
    if (this.redirectSource == 'talent-insights' && this.redirectDataV2?.keywordSelectedList?.length) {
      return this.redirectDataV2.keywordSelectedList.map(el => el.chipkey);
    } else if (this.bucketbooleanquery) {
      return this.bucketbooleanquery
    } else if (this.sourceRedirectRef && this.sourceRedirectRef == 'bucket') {
      return "*";
    } else if (this.searchKeyword == "") {
      return "*"
    } else {
      return this.searchKeyword;
    }
  }

  /**Get "genders" key for  "getPersonSearchRecommendedCandidates" request body*/
  getGenderInfo(filterData) {
    if (this.redirectSource == 'company-insights') {
      return [this.companyredirectData.gender];
    } else if (filterData?.gender != '') {
      return filterData?.gender?.length ? [filterData.gender] : []
    } else return [];
  }

  /**Get "mandatorylocations" key for "getPersonSearchRecommendedCandidates" request body  */
  getMandatoryLocations() {
    if (this.redirectSource == 'talent-insights' && this.redirectData?.mandatorylocations?.length) {
      return this.redirectData.mandatorylocations
    } else if (this.redirectSource == 'company-insights') {
      return this.redirectData.mandatorylocations
    } else return [];
  }

  /**Get "fromyearsofexperience", "toyearsofexperience", "currentfromyearsofexperience", "currenttoyearsofexperience" key for "getPersonSearchRecommendedCandidates" reuest body  */
  getExperienceWithKeys(key, filterData) {
    if (key === "fromyearsofexperience") {
      if ((this.redirectSource == 'talent-insights' || this.redirectSource == 'company-insights') && this.redirectDataV2?.yearsofexperienceFrom && !filterData?.yearsofexperienceFrom) {
        return [this.redirectDataV2?.yearsofexperienceFrom];
      }
      else if (!!filterData?.yearsofexperienceFrom) {
        return [filterData.yearsofexperienceFrom]
      }
      else return [];
    }
    else if (key === "toyearsofexperience") {
      if ((this.redirectSource == 'talent-insights' || this.redirectSource == 'company-insights') && this.redirectDataV2?.yearsofexperienceTo && !filterData?.yearsofexperienceTo) {
        return [this.redirectDataV2?.yearsofexperienceTo]
      }
      else if (!!filterData?.yearsofexperienceTo) {
        return [filterData.yearsofexperienceTo];
      }
      else return [];
    }
    else if (key === "currentfromyearsofexperience") {
      if ((this.redirectSource == 'talent-insights' || this.redirectSource == 'company-insights') && this.redirectDataV2?.currentfromyearsofexperience && !filterData?.currentfromyearsofexperience) {
        return [this.redirectDataV2?.currentfromyearsofexperience]
      }
      else if (!!filterData?.currentfromyearsofexperience) {
        return [filterData.currentfromyearsofexperience];
      }
      else return [];
    }
    else if (key === 'currenttoyearsofexperience') {
      if ((this.redirectSource == 'talent-insights' || this.redirectSource == 'company-insights') && this.redirectDataV2?.currenttoyearsofexperience && !filterData?.currenttoyearsofexperience) {
        return [this.redirectDataV2?.currenttoyearsofexperience];
      } else if (!!filterData?.currenttoyearsofexperience) {
        return [filterData?.currenttoyearsofexperience];
      } else return [];
    }
  }

  /**
   * Get Value of insight keys required for "getPersonSearchRecommendedCandidates" request body
   * @param key required key for data, which have to pass in request object
   * @param filterData 
   */
  getInsightsObjectKeyValue(key) {
    if (key === "insightslocations") {
      if (this.redirectSource == 'talent-insights') {
        return this.redirectData.location;
      } else if (this.redirectSource == 'company-insights' && this.companyredirectData.locationSelectedList.length) {
        return this.companyredirectData.locationSelectedList.map(el => el.key)
      } else return [];
    }
    else if (key === "insightscompanies") {
      if (this.redirectSource === 'talent-insights') {
        return this.redirectData.company;
      } else if (this.redirectSource === 'company-insights' && this.redirectData.losingtalent) {
        return this.redirectData.losingtalent;
      } else if (this.redirectSource === 'company-insights' && this.redirectData.alternative_names) {
        return this.redirectData.alternative_names.concat(this.redirectData.name);
      } else if (this.redirectSource === 'company-insights' && !this.redirectData.alternative_names) {
        return [this.redirectData.name];
      } else {
        return [];
      }
    }
    else if (key === "insightsindustries") {
      if (this.redirectSource == 'talent-insights') {
        return this.redirectData.industry;
      } else if (this.redirectSource == 'company-insights') {
        return this.companyredirectData.industrySelectedList?.map(el => el.key);
      }
      else return [];
    }
    else if (key === "insightsschools") {
      if (this.redirectSource == 'talent-insights') {
        return this.redirectData.school;
      }
      else if (this.redirectSource == 'company-insights') {
        return this.companyredirectData.schoolSelectedList?.map(el => el.key);
      }
      else return [];
    }
    else if (key === "insightseducationalmajors") {
      if (this.redirectSource == 'talent-insights') {
        return this.redirectData.fieldofstudy;
      } else if (this.redirectSource == 'company-insights') {
        return this.companyredirectData.fieldOfStudySelectedList?.map(el => el.key);
      } else return [];
    }
    else if (key === "insightsjobtitles") {
      if (this.redirectSource == 'talent-insights') {
        return this.redirectData.jobtitle;
      } else if (this.redirectSource == 'company-insights') {
        return this.companyredirectData.jobTitleSelectedList?.map(el => el.key);
      }
      else return [];
    }
    else if (key === "insightsfunctions") {
      if (this.redirectSource == 'talent-insights' && this.redirectData.function) {
        return this.redirectData.function.filter(Boolean);
      }
      else if (this.redirectSource == 'company-insights') {
        return this.companyredirectData.functionSelectedList.map(el => el.key);
      } else return [];
    }
    else if (key === "lastjobcompanies") {
      if (this.redirectSource == 'company-insights' && this.redirectData.winningtalent) {
        return this.redirectData.winningtalent;
      }
      else if (this.redirectSource == 'company-insights' && this.redirectData.losingtalent && this.redirectData.alternative_names) {
        return this.redirectData.alternative_names.concat(this.redirectData.name);
      } else if (this.redirectSource == 'company-insights' && this.redirectData.losingtalent && !this.redirectData.alternative_names) {
        return [this.redirectData.name];
      } else return [];
    }
    else if (key === "insightseducationaldegrees") {
      if (this.redirectSource == 'talent-insights') {
        return this.redirectData.degree;
      } else if (this.redirectSource == 'company-insights') {
        return this.companyredirectData.educationSelectedList?.map(el => el.key);
      }
      else return [];
    }
    else if(key === 'insightspreferredskills'){
      if (this.redirectSource === 'talent-insights') {
        return this.redirectData.skills;
      } else if (this.redirectSource === 'company-insights') {
        return this.companyredirectData.skillsSelectedList
          .filter(s => s.isMandatory === false)
          .map(el => el.key);
      } else {
        return [];
      }
    }
    else if (key === "insightsseniority") {
      if (this.redirectSource == 'talent-insights') {
        return this.redirectData.seniority;
      } else if (this.redirectSource == 'company-insights') {
        return this.companyredirectData.seniority
      } else return [];
    }
  }

  /**
   *
   * @param object -
   * @param firstcall - Pass this as true if we need to send aggregate call for only stats matrix (likely to move in, gender, changed jobs)
   *
   */
  getPersonSearchRecommendedCandidates(object: any = null, firstcall = false) {
    if(this.jdDataService.isComingFromJobDescription) {

    }
    const filterData = this.filterDataHandlerService.fetchFilterData;
    this.searchKeyword = this.route.snapshot.queryParams.keyword;
    if(this.isInsightsActive == true) {
      const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
      //loadn[0].style.display = 'none'
    }
    this.requestObject = {
      startindex: this.start,
      resultsize: 20,
      searchviaboolean: true,
      // TODO : Use redirect data here set from local storage
      booleanquery: this.getBooleanQuery(),
      jobtitles: _.uniq(filterData.jobTitleSelectedList.filter(jobTitle => jobTitle.isExcluded == false).map(j => j.key)),
      pastjobtitles: _.uniq(filterData.pastJobTitleSelectedList.filter(jobTitle => !jobTitle.isExcluded).map(j => j.key)),
      exclude_pastjobtitles: _.uniq(filterData.pastJobTitleSelectedList.filter(jobTitle => !!jobTitle.isExcluded).map(j => j.key)),
      preferredskills: filterData.skillsSelectedList.filter(s => s.isMandatory == false).map(s => s.key),
      mandatoryskills: this.getMandatorySkills,
      locations: filterData.locationSelectedList && filterData.locationSelectedList.length ? filterData.locationSelectedList.filter(l => l.isExcluded == false).map(l => l.key) : this.geoIpLocation && this.selectedContinent && this.selectedContinent.length && this.geoIpLocation.continent == this.selectedContinent[0] ? [`${this.geoIpLocation.location}.iplocation`] : [],
      companies: filterData.companySelectedList.filter(company => company.isExcluded == false).map(j => j.key),
      industries: filterData.industrySelectedList.filter(industry => industry.isExcluded == false).map(i => i.key),
      exclusionlist: [],
      genders: this.getGenderInfo(filterData),
      // TODO : Test properly
      seniority: filterData.seniority ? _.flatten(filterData.seniority): [],
      graduationyear: this.graduationYearSelectedList.map(gy => gy.key),
      schools: filterData.schoolSelectedList.map(s => s.key),
      schooltypes: [],
      schoollocation: _.uniq(filterData.schoolLocationSelectedList.filter(sl => !sl.isExcluded).map(j => j.key)),
      educationaldegrees: filterData.educationSelectedList.map(e => e.key),
      educationalmajors: filterData.fieldOfStudySelectedList.map(fs => fs.key),
      candidateshavingemails: false,
      candidateshavingcontactnumbers: false,
      minexperience: null,
      maxexperience: null,
      minexperienceinccurrentcompany: null,
      zipcodes: this.zipCodeSelectedList.map(z => z.key),
      companysizes: filterData.companysize ? _.flatten(filterData.companysize) : [],
      candidateshavingcontacts: this.contactsAvailabilitySelectedFromInsights ? true : this.contacts != 'All' ? true : false,
      workregions: this.currentWorkCitySelectedList.map(wc => wc.key),
      workcountries: this.currentWorkCountrySelectedList.map(wc => wc.key),
      worklocalities: this.currentWorkLocalitySelectedList.map(c => c.key),
      spokenlanguages: this.languageSelectedList.map(l => l.key),
      contacts: this.contacts ? [this.contacts] : [],
      candidateshavingmobilenumber: this.contactSelectedList.find(c => c.key.toLowerCase() == 'mobile number') ? true : false,
      candidateshavingpersonalemail: this.contactSelectedList.find(c => c.key.toLowerCase() == 'personal email') ? true : false,
      candidateshavingprofessionalemail: this.contactSelectedList.find(c => c.key.toLowerCase() == 'current professional email') ? true : false,
      candidateshavingsocialprofiles: this.contactSelectedList.find(c => c.key.toLowerCase() == 'social profiles') ? true : false,
      fromgraduationyears: this.yearsofgraduationFrom.value != null ? [this.yearsofgraduationFrom.value] : [],
      tograduationyears: this.yearsofgraduationTo.value != null ? [this.yearsofgraduationTo.value] : [],
      exclude_jobtitles: this.redirectSource == 'company-insights' ? this.companyredirectData.jobTitleSelectedList.filter(j => j.isExcluded == true).map(j => j.key): filterData.jobTitleSelectedList.filter(j => j.isExcluded == true).map(j => j.key),
      exclude_companies: this.redirectSource == 'company-insights' ? this.companyredirectData.companySelectedList.filter(j => j.isExcluded == true).map(j => j.key): filterData.companySelectedList.filter(j => j.isExcluded == true).map(j => j.key),
      exclude_locations: this.redirectSource == 'company-insights' ? this.companyredirectData.locationSelectedList.filter(j => j.isExcluded == true).map(j => j.key): filterData.locationSelectedList.filter(j => j.isExcluded == true).map(j => j.key),
      exclude_schoollocation: _.uniq(filterData.schoolLocationSelectedList.filter(sl => !!sl.isExcluded).map(j => j.key)),
      companytype: filterData.companyStatus == 'Current or Past' ? 'All' : filterData.companyStatus,
      jobtitletype: filterData.jobTitleStatus == 'Current or Past' ? 'All' : filterData.jobTitleStatus,
      industrytype: filterData.industryStatus == 'Current or Past' ? 'All' : filterData.industryStatus,
      functiontype: (this.redirectSource == 'company-insights' || this.redirectSource == 'talent-insights') ? 'Current': 'All',
      // fromyearsofexperience: (this.redirectSource == 'talent-insights' || this.redirectSource == 'company-insights') && this.redirectData.fromyearsofexperience && !filterData.yearsofexperienceFrom ? [this.redirectData.fromyearsofexperience] : !!filterData.yearsofexperienceFrom ? [filterData.yearsofexperienceFrom] : [],
      // toyearsofexperience: (this.redirectSource == 'talent-insights' || this.redirectSource == 'company-insights') && this.redirectData.toyearsofexperience && !filterData.yearsofexperienceTo ? [this.redirectData.toyearsofexperience] : !!filterData.yearsofexperienceTo ? [filterData.yearsofexperienceTo] : [],
      experiencetype: filterData.yearsofexperience,
      likelytomovetype: filterData.candidateslikelytomove,
      salaries: this.salary ? [this.salary] : [],
      salaryranges: this.salary ? [this.salary] : [],
      talentdiscoveryhistoryid: this.talentdiscoveryhistoryid,
      calledfrom: 'listing',
      mandatoryjobtitles: this.redirectData?.mandatoryjobtitles?.length ? this.redirectData.mandatoryjobtitles : [],
      mandatorylocations: this.getMandatoryLocations(),
      mandatorycompanies: this.redirectData?.mandatorycompanies?.length ? this.redirectData.mandatorycompanies : [],
      mandatoryindustries: this.redirectData?.mandatoryindustries?.length ? this.redirectData.mandatoryindustries : [],
      mandatoryschools: this.redirectData?.mandatoryschools?.length ? this.redirectData.mandatoryschools : [],
      mandatoryfunctions: this.redirectData?.mandatoryfunctions?.length ? this.redirectData.mandatoryfunctions : [],
      mandatoryeducationalmajors: this.redirectData?.mandatoryeducationalmajors?.length ? this.redirectData.mandatoryeducationalmajors : [],
      continentstobeincluded: this.selectedContinent,
      functions: filterData.functionSelectedList.map(l => l.key),
      fullnames: filterData?.fullnameSelectedList?.length ? filterData.fullnameSelectedList.map(f=>f.key): [],
      searchedfrom: this.searchedfrom,

      //  zone: this.localstorageservice.getItem('region')
      ...((this.redirectSource == 'talent-insights' || this.redirectSource == 'company-insights') && this.redirectData && { recentgraduatesonly: this.redirectData.recentgraduatesonly }),
      ...((this.redirectSource == 'talent-insights' || this.redirectSource == 'company-insights') && this.redirectData && { recentcompanyhires: this.redirectData.recentcompanyhires }),
      ...((this.redirectSource == 'talent-insights' || this.redirectSource == 'company-insights') && this.redirectData && { recentcompanyattrition: this.redirectData.recentcompanyattrition }),
      changedjobs: filterData.changedJobStatus,
      // currentfromyearsofexperience: this.currentfromyearsofexperience.value != null ? [this.currentfromyearsofexperience.value] : [],
      // currenttoyearsofexperience: this.currenttoyearsofexperience.value != null ? [this.currenttoyearsofexperience.value] : [],
      insightslocations: this.getInsightsObjectKeyValue("insightslocations"),
      insightscompanies: this.getInsightsObjectKeyValue("insightscompanies"),
      insightsindustries: this.getInsightsObjectKeyValue("insightsindustries"),
      insightsschools: this.getInsightsObjectKeyValue("insightsschools"),
      insightseducationalmajors: this.getInsightsObjectKeyValue("insightseducationalmajors"),
      insightsjobtitles: this.getInsightsObjectKeyValue("insightsjobtitles"),
      insightspreferredskills: this.getInsightsObjectKeyValue("insightspreferredskills"),
      insightsfunctions: this.getInsightsObjectKeyValue("insightsfunctions"),
      lastjobcompanies: this.getInsightsObjectKeyValue("lastjobcompanies"),
      insightseducationaldegrees: this.getInsightsObjectKeyValue("insightseducationaldegrees"),
      insightsseniority: this.getInsightsObjectKeyValue("insightsseniority"),
      needcuratedtalentpooltags: true,
      fromyearsofexperience: this.getExperienceWithKeys("fromyearsofexperience",filterData),
      toyearsofexperience: this.getExperienceWithKeys("fromyearsofexperience", filterData),
      currentfromyearsofexperience: this.getExperienceWithKeys("currentfromyearsofexperience", filterData),
      currenttoyearsofexperience: this.getExperienceWithKeys("currenttoyearsofexperience", filterData),
      exclude_industries: filterData.industrySelectedList.filter(i =>i.isExcluded == true).map(i => i.key),
      distancefromselectedlocations: filterData?.distancefromselectedlocations,
      distancefromselectedlocationsmeasurementunit: filterData?.distancefromselectedlocationsmeasurementunit
    };
    this.aggReqObjectHandlerService.setShareRequestObject(this.requestObject);
    this.filterDataHandlerService.setBooleanQuery(this.requestObject?.booleanquery);
    if (this.filterDataHandlerService.isRedirectFromTalentInsightsPage || this.jdDataService.isComingFromJobDescription) {
      this.requestObject = this.aggregationService.getRequestWithFilters();
    }
    // TODO : Handle all the filters related data in a helper method
    if (object != null && typeof object === 'object' && this.searchedfrom !== GeneralConstants.REDIRECT_SOURCES.JOB_DESCRIPTION) {
      this.requestObject = object;
      this.filterDataHandlerService.setBooleanQuery(this.requestObject?.booleanquery);
      if (!this.filterDataHandlerService.isRedirectFromTalentInsightsPage) this.requestObject['calledfrom'] = 'listing'
    }

    if (this.bucketId && this.sourceRedirectRef && this.sourceRedirectRef == 'bucket') {
      this.requestObject['talentpoolbucketid'] = this.bucketId
      this.requestObject['talentpoolbucketname'] = this.bucketName
    } else {
      this.requestObject['talentpoolbucketname'] = this.bucketName
    }

    if (this.similarobject && this.similarobject.data && this.searchedfrom !== GeneralConstants.REDIRECT_SOURCES.JOB_DESCRIPTION) {
      const fromyrsofexperience = this.similarobject.data.fromYrsOfExperience;
      const toyrsofexperinece = this.similarobject.data.toYrsOfExperinece;

      this.requestObject['similarcandidates_industries'] = !Array.isArray(this.similarobject.data.jobindustryname) ? [this.similarobject.data.jobindustryname]: this.similarobject.data.jobindustryname
      this.requestObject['similarcandidates_locations'] = this.similarobject.data.currentlocation
      this.requestObject['similarcandidates_skills'] = this.similarobject.data.skills
      this.requestObject['similarcandidates_companysizes'] = this.similarobject.data.companysize != null ? this.similarobject.data.companysize: []
      this.requestObject['similarcandidates_fromyearsofexperience'] = fromyrsofexperience != null ? [fromyrsofexperience] : []
      this.requestObject['similarcandidates_toyearsofexperience'] = toyrsofexperinece != null ? [toyrsofexperinece] : []
      this.requestObject['similarcandidates_toyearsofexperience'] = toyrsofexperinece != null ? [toyrsofexperinece] : []
      this.requestObject['similarcandidates_totaltenure'] = this.similarobject.data.totaltenure
      this.requestObject['similarcandidates_jobtitles'] = this.similarobject.data.jobtitle || [];
      this.requestObject['similarcandidates_companies'] = this.similarobject.data.jobcompanyname || [];

      // extra information for history
      this.requestObject['linkedinurl'] = this.similarobject.data.linkedinurl
      this.requestObject['isUploadedFromResume'] = this.similarobject.data.isUploadedFromResume
      this.requestObject['fullname'] = this.similarobject.data.fullname


      if (this.similarobject.data.elasticid) {
        this.requestObject['exclude_persons'] = [this.similarobject.data.elasticid]
      }
    }
    this.showLoaderbeforeDataLoad = true;
    if (this.similarCandidateService.isListingCalledFromSimilarCandidate) {
      this.requestObject.continentstobeincluded = this.similarobject?.data?.locationcontinent ? [this.similarobject.data.locationcontinent]: [];
      delete this.requestObject.needcuratedtalentpooltags;
    }
    if(this.similarCandidateService.isListingCalledFromSimilarCandidate || this.filterDataHandlerService.isRedirectFromCompanyInsightsPage || 
      this.jdDataService.isComingFromJobDescription || this.filterDataHandlerService.isRedirectFromTalentInsightsPage ) {
        delete this.requestObject?.distancefromselectedlocations;
        delete this.requestObject?.distancefromselectedlocationsmeasurementunit;
    }
    this.aggReqObjectHandlerService.setShareRequestObject(this.requestObject);
    this.turnOnLoaders(false);

    if (
      this.filterDataHandlerService.isRedirectFromCompanyInsightsPage &&
      this.requestObject?.calledfrom
    ) {
      delete this.requestObject.calledfrom;
    }
    

    this.personSearchService.getPersonSearchRecommendCandidates(this.requestObject).subscribe(response => {
      if (response.status == 'success') {
        response.data.candidateList = response?.data?.results?.length ? response.data.results.map(c => ({ ...c, selected: false })) : [];
        this.showLoaderbeforeDataLoad = false;
        if(this.generateAIMOdalLoader == true) {
          this.modalService.dismissAll();
         }
      //  this.handleGetPersonSearchAPI(response?.data);
        const candidateObject = new PersonSearchResponse();
          candidateObject.candidateList = response?.data?.results?.length ? response.data.results.map(c => ({ ...c, selected: false })) : [];
          candidateObject.totalCandidatesCount = response.data?.totalresultscount;
          candidateObject.talentdiscoveryhistoryid = response?.data?.talentdiscoveryhistoryid;
          candidateObject.totalresultscount = response?.data?.totalresultscount;
          candidateObject.booleanquery = response?.data?.booleanquery;        
          this.aggregationService.emitRecCandidateObject(candidateObject);
      }
      this.totalCandidatesCountAvailable = true;
    });
  }

  createFilterCharts(filterName: 'years_of_exp' | 'years_of_grad' = null) {

    // if no filter or years_of_exp filter provided
    if (!filterName || (filterName && filterName === 'years_of_exp')) {
      let CharForYearsOfExperience = [];

      if (this.yearsofexperience == 'Current') {
        this.reportsAggs && this.reportsAggs.currentyearsofexperience && this.reportsAggs.currentyearsofexperience.forEach(x => {
          let dataObj = {
            label: `${x.key}`,
            value: x.doc_count,
            tooltext: `${x.key} <br> Talent count: ${x.doc_count}`
          }
          CharForYearsOfExperience.push(dataObj)
        })
        this.dataSourceYearsOfExperience = {
          dataFormat: "json",
          height: 14,
          width: 14,
          chart: {
            renderAt: "chart-container",
            "paletteColors": "#F4AB33",
            "captionFontColor": "#F4AB33",
            "showPercentValues": "1",
            "yAxisNameFontColor": '#F4AB33',
            legendPosition: "right",
            legendAllowDrag: "1",
            theme: "fusion",
            "labelFont": "Poppins",
            legendItemFont: "Poppins",
            "baseFont": "Poppins",
            "baseFontSize": "11",
            drawanchors: "0",
            showToolTip: "1",
            showValues: "0",
            showYAxisValues: "0",
          },
          "data": CharForYearsOfExperience
        };
      } else if (this.yearsofexperience == 'Total') {
        this.reportsAggs && this.reportsAggs.totalyearsofexperience && this.reportsAggs.totalyearsofexperience.forEach(x => {
          let dataObj = {
            label: `${x.key}`,
            value: x.doc_count,
            tooltext: `${x.key} <br> Talent count: ${x.doc_count}`
          }
          CharForYearsOfExperience.push(dataObj)
        })
        this.dataSourceYearsOfExperience = {
          dataFormat: "json",
          height: 14,
          width: 14,
          chart: {
            renderAt: "chart-container",
            "paletteColors": "#F4AB33",
            "captionFontColor": "#F4AB33",
            "showPercentValues": "1",
            "yAxisNameFontColor": '#F4AB33',
            legendPosition: "right",
            legendAllowDrag: "1",
            theme: "fusion",
            "labelFont": "Poppins",
            legendItemFont: "Poppins",
            "baseFont": "Poppins",
            "baseFontSize": "11",
            drawanchors: "0",
            showToolTip: "1",
            showValues: "0",
            showYAxisValues: "0",
          },
          "data": CharForYearsOfExperience
        };
      } else if (this.yearsofexperience == 'Average') {
        this.reportsAggs && this.reportsAggs.averageyearsofexperience && this.reportsAggs.averageyearsofexperience.forEach(x => {
          let dataObj = {
            label: `${x.key}`,
            value: x.doc_count,
            tooltext: `${x.key} <br> Talent count: ${x.doc_count}`
          }
          CharForYearsOfExperience.push(dataObj)
        })

        this.dataSourceYearsOfExperience = {
          dataFormat: "json",
          height: 14,
          width: 14,
          chart: {
            renderAt: "chart-container",
            "paletteColors": "#F4AB33",
            "captionFontColor": "#F4AB33",
            "showPercentValues": "1",
            "yAxisNameFontColor": '#F4AB33',
            legendPosition: "right",
            legendAllowDrag: "1",
            theme: "fusion",
            "labelFont": "Poppins",
            legendItemFont: "Poppins",
            "baseFont": "Poppins",
            "baseFontSize": "11",
            drawanchors: "0",
            showToolTip: "1",
            showValues: "0",
            showYAxisValues: "0",
          },
          "data": CharForYearsOfExperience
        };
      }

    }
    // if no filter or years_of_grad filter provided
    if (!filterName || (filterName && filterName === 'years_of_grad')) {
      let CharForYearsOfGraduation = [];

      this.reportsAggs && this.reportsAggs.graduationyear && this.reportsAggs.graduationyear.forEach(x => {
        if (this.yearsofgraduationFrom.value != null && this.yearsofgraduationTo.value != null && parseInt(x.key) >= parseInt(this.yearsofgraduationFrom.value) && parseInt(x.key) <= parseInt(this.yearsofgraduationTo.value)) {
          let dataObj = {
            label: `${x.key}`,
            value: x.doc_count,
            tooltext: `${x.key} <br> Professional count: ${x.doc_count}`
          }
          CharForYearsOfGraduation.push(dataObj);
        } else {
          let dataObj = {
            label: `${x.key}`,
            value: x.doc_count,
            tooltext: `${x.key} <br> Professional count: ${x.doc_count}`
          }
          CharForYearsOfGraduation.push(dataObj);
        }
      });
      this.dataSourceYearsOfGraduation = {
        "type": "column2d",
        "dataFormat": "json",
        "chart": {
          "paletteColors": "#F4AB33",
          "captionFontColor": "#575757",
          "showPercentValues": "1",
          showYAxisValues: "0",
          "legendAllowDrag": "1",
          "theme": "fusion",
          valuePosition: 'right',
        },
        "data": CharForYearsOfGraduation
      };
    }
  }

  changeJobTitleStatus(status: string) {
    this.jobTitleStatus = status;
    this.getPersonSearchRecommendedCandidates();
  }

  setPage(index: number) {
    this.candidatetoBeGrabbed = []
    this.totalCandidateforTalentpool = []
    this.selected = false;

    let start = (index - 1) * this.pageSize
    this.start = start
    this.end = this.start + this.pageSize
    if(index == 1) this.currentPage = 1;
    if (this.end > this.totalCandidatesCount) {
      this.end = this.totalCandidatesCount
    }
      this.getPersonSearchRecommendedCandidates(null, true);

      this.document.documentElement.scrollTop = 0;
  }

  onTabChange(tab) {
    if (tab == 'insight') {
      // reports tab
      this.isInsightsActive = true;
      this.isListingActive = false;
      this.requestObject['talentdiscoveryhistoryid'] = this.talentdiscoveryhistoryid
      this.requestObject['isinsightsviewed'] = 1
      this.insightsDataService.setInsightsActive(true);
    } else {
      // profiles tab
      this.isListingActive = true;
      this.isInsightsActive = false;
      this.insightsDataService.setInsightsActive(false);
    }
  }

  getUpdatedCountForSelectedFilters() {
    this.contactsAvailableArray = this.contactsAvailableArray.map(x => {
      let mobilenumber = this.aggregations.mobilenumber && this.aggregations.mobilenumber.doc_count ? this.aggregations.mobilenumber.doc_count : 0;
      let personalemail = this.aggregations.personalemail && this.aggregations.personalemail.doc_count ? this.aggregations.personalemail.doc_count : 0;
      let professionalemail = this.aggregations.professionalemail && this.aggregations.professionalemail.doc_count ? this.aggregations.professionalemail.doc_count : 0;
      let socialprofiles = this.aggregations.socialprofiles && this.aggregations.socialprofiles.doc_count ? this.aggregations.socialprofiles.doc_count : 0;

      if (x.key.toLowerCase() == 'mobile number') {
        x.doc_count = mobilenumber;
      } else if (x.key.toLowerCase() == 'personal email') {
        x.doc_count = personalemail;
      } else if (x.key.toLowerCase() == 'current professional email') {
        x.doc_count = professionalemail;
      } else if (x.key.toLowerCase() == 'social profiles') {
        x.doc_count = socialprofiles;
      }
      return x;
    });

    if (this.jobTitleSelectedList.length) {
      this.jobTitleSelectedList = this.jobTitleSelectedList.map(x => {
        let jobTitleObj = this.jobTitleStatus == 'All' ? this.aggregations.jobtitle.find(y => y.key.toLowerCase() == x.key.toLowerCase()) : this.aggregations.current_jobtitle.find(y => y.key.toLowerCase() == x.key.toLowerCase());
        if (jobTitleObj) {
          x.doc_count = jobTitleObj.doc_count;
        } else {
          x.doc_count = 0;
        }
        return x;
      });
    }

    if (this.currentWorkCitySelectedList.length) {
      this.currentWorkCitySelectedList = this.currentWorkCitySelectedList.map(x => {
        let currentWorkCityObj = this.jobTitleStatus == 'All' ? this.aggregations.workregion.find(y => y.key.toLowerCase() == x.key.toLowerCase()) : this.aggregations.current_workregion.find(y => y.key.toLowerCase() == x.key.toLowerCase());
        if (currentWorkCityObj) {
          x.doc_count = currentWorkCityObj.doc_count;
        } else {
          x.doc_count = 0;
        }
        return x;
      });
    }

    if (this.currentWorkCountrySelectedList.length) {
      this.currentWorkCountrySelectedList = this.currentWorkCountrySelectedList.map(x => {
        let currentWorkCountryObj = this.jobTitleStatus == 'All' ? this.aggregations.workcountry.find(y => y.key.toLowerCase() == x.key.toLowerCase()) : this.aggregations.current_workcountry.find(y => y.key.toLowerCase() == x.key.toLowerCase());
        if (currentWorkCountryObj) {
          x.doc_count = currentWorkCountryObj.doc_count;
        } else {
          x.doc_count = 0;
        }
        return x;
      });
    }

    if (this.currentWorkLocalitySelectedList.length) {
      this.currentWorkLocalitySelectedList = this.currentWorkLocalitySelectedList.map(x => {
        let currentWorkLocalityObj = this.jobTitleStatus == 'All' ? this.aggregations.worklocality.find(y => y.key.toLowerCase() == x.key.toLowerCase()) : this.aggregations.current_worklocality.find(y => y.key.toLowerCase() == x.key.toLowerCase());
        if (currentWorkLocalityObj) {
          x.doc_count = currentWorkLocalityObj.doc_count;
        } else {
          x.doc_count = 0;
        }
        return x;
      });
    }

    if (this.skillsSelectedList.length) {
      this.skillsSelectedList = this.skillsSelectedList.map(x => {
        let skillsObj = this.aggregations.skills.find(y => y.key.toLowerCase() == x.key.toLowerCase());
        if (skillsObj) {
          x.doc_count = skillsObj.doc_count;
        } else {
          x.doc_count = 0;
        }
        return x;
      });
    }

    if (this.companySelectedList.length) {
      this.companySelectedList = this.companySelectedList.map(x => {
        let companyObj = this.jobTitleStatus == 'All' ? this.aggregations.company.find(y => y.key.toLowerCase() == x.key.toLowerCase()) : this.aggregations.current_company.find(y => y.key.toLowerCase() == x.key.toLowerCase());
        if (companyObj) {
          x.doc_count = companyObj.doc_count;
        } else {
          x.doc_count = 0;
        }
        return x;
      });
    }

    if (this.industrySelectedList.length) {
      this.industrySelectedList = this.industrySelectedList.map(x => {
        let industryObj = this.jobTitleStatus == 'All' ? this.aggregations.industry.find(y => y.key.toLowerCase() == x.key.toLowerCase()) : this.aggregations.current_industry.find(y => y.key.toLowerCase() == x.key.toLowerCase());
        if (industryObj) {
          x.doc_count = industryObj.doc_count;
        } else {
          x.doc_count = 0;
        }
        return x;
      });
    }

    if (this.fieldOfStudySelectedList.length) {
      this.fieldOfStudySelectedList = this.fieldOfStudySelectedList.map(x => {
        let fieldOfStudyObj = this.aggregations.fieldofstudy.find(y => y.key.toLowerCase() == x.key.toLowerCase());
        if (fieldOfStudyObj) {
          x.doc_count = fieldOfStudyObj.doc_count;
        } else {
          x.doc_count = 0;
        }
        return x;
      });
    }

    if (this.educationSelectedList.length) {
      this.educationSelectedList = this.educationSelectedList.map(x => {
        let educationObj = this.aggregations.education.find(y => y.key.toLowerCase() == x.key.toLowerCase());
        if (educationObj) {
          x.doc_count = educationObj.doc_count;
        } else {
          x.doc_count = 0;
        }
        return x;
      });
    }

    if (this.zipCodeSelectedList.length) {
      this.zipCodeSelectedList = this.zipCodeSelectedList.map(x => {
        let zipCodeObj = this.aggregations.zipcodes.find(y => y.key.toLowerCase() == x.key.toLowerCase());
        if (zipCodeObj) {
          x.doc_count = zipCodeObj.doc_count;
        } else {
          x.doc_count = 0;
        }
        return x;
      });
    }

    if (this.schoolSelectedList.length) {
      this.schoolSelectedList = this.schoolSelectedList.map(x => {
        let schoolObj = this.aggregations.school.find(y => y.key.toLowerCase() == x.key.toLowerCase());
        if (schoolObj) {
          x.doc_count = schoolObj.doc_count;
        } else {
          x.doc_count = 0;
        }
        return x;
      });
    }

    if (this.companySizeSelectedList.length) {
      this.companySizeSelectedList = this.companySizeSelectedList.map(x => {
        let companySizeObj = this.jobTitleStatus == 'All' ? this.aggregations.companysizes.find(y => y.key.toLowerCase() == x.key.toLowerCase()) : this.aggregations.current_companysizes.find(y => y.key.toLowerCase() == x.key.toLowerCase());
        if (companySizeObj) {
          x.doc_count = companySizeObj.doc_count;
        } else {
          x.doc_count = 0;
        }
        return x;
      });
    }

    if (this.graduationYearSelectedList.length) {
      this.graduationYearSelectedList = this.graduationYearSelectedList.map(x => {
        let graduationYearObj = this.aggregations.graduationyear.find(y => y.key.toLowerCase() == x.key.toLowerCase());
        if (graduationYearObj) {
          x.doc_count = graduationYearObj.doc_count;
        } else {
          x.doc_count = 0;
        }
        return x;
      });
    }

    if (this.locationSelectedList.length) {
      this.locationSelectedList = this.locationSelectedList.map(x => {
        let locationObj = this.aggregations.location.find(y => y.key.toLowerCase() == x.key.toLowerCase());
        if (locationObj) {
          x.doc_count = locationObj.doc_count;
        } else {
          x.doc_count = 0;
        }
        return x;
      });
    }

    if (this.languageSelectedList.length) {
      this.languageSelectedList = this.languageSelectedList.map(x => {
        let languageObj = this.aggregations.language.find(y => y.key.toLowerCase() == x.key.toLowerCase());
        if (languageObj) {
          x.doc_count = languageObj.doc_count;
        } else {
          x.doc_count = 0;
        }
        return x;
      });
    }

    if (this.functionSelectedList.length) {
      this.functionSelectedList = this.functionSelectedList.map(x => {
        let functionObj = this.aggregations.function.find(y => y.key.toLowerCase() == x.key.toLowerCase());
        if (functionObj) {
          x.doc_count = functionObj.doc_count;
        } else {
          x.doc_count = 0;
        }
        return x;
      });
    }
  }

  selectCandidate(e, data) {
    if ((e && e.target && e.target.checked) || e == 'selected') {
      if (this.candidatetoBeGrabbed && this.candidatetoBeGrabbed.length < 100) {
        if (this.candidatetoBeGrabbed && this.candidatetoBeGrabbed.length) {
          if (!this.candidatetoBeGrabbed.some(candidate => candidate.idinindex == data.idinindex)) {
            this.candidatetoBeGrabbed.push(data)
          }
        } else {
          this.candidatetoBeGrabbed.push(data)
        }
        data.selected = true
        if (this.candidateList && this.candidatetoBeGrabbed && (this.candidateList.length == this.candidatetoBeGrabbed.length)) {
          this.selected = true;
        }
      } else {
        data.selected = false
        e.target.checked = false;
      }
    } else {
      this.selected = false
      data.selected = false
      e.target.checked = false;
      this.candidatetoBeGrabbed = this.candidatetoBeGrabbed.filter(x => x['idinindex'] != data.idinindex)
    }
  }

  selectAll(e) {
    if (e.target.checked && this.candidatetoBeGrabbed.length < 100) {
      this.candidateList.forEach((x: any) => {
        let event = {
          target: {
            checked: true
          }
        }
        this.selectCandidate(event, x);
      })
    } else {
      this.totalCandidateforTalentpool = []
      this.candidatetoBeGrabbed = []
      this.selected = false
      e.target.checked = false;
      this.candidateList.forEach((x: any) => {
        let event = {
          target: {
            checked: false
          }
        }
        this.selectCandidate(event, x);
      })
    }
  }

  extractCandidate(candidateData: any) {
    this.profileurlsarray = []
    this.profileurlsarray.push(candidateData.idinindex)
    this.profileurlsarray = this.profileurlsarray.filter((item,
      index) => this.profileurlsarray.indexOf(item) === index);
      this.disablebutton = true;
    const modalRef = this.modalService.open(this.extractToTalentpool, { windowClass: "modalExtract", centered: true });
    modalRef.result.then((data) => {
    },
      (error) => {
        if (error != 'isGrabbed') {
          this.modalDismissed = true;
        }
      });
  }

  saveDataToTalentpool(talentpoolData = null) {
    const profileurlsarray = {
      profileurlsarray: talentpoolData
    }
    let talentpoolProfileAndData = {}
    if (this.talentpoolAndCandidateData && this.talentpoolAndCandidateData.profileurlsarray && this.talentpoolAndCandidateData.profileurlsarray.length) {
      talentpoolProfileAndData = {
        talentpoolname: this.talentpoolAndCandidateData.talentpoolname,
        talentpoolnumber: this.talentpoolAndCandidateData.talentpoolnumber,
        elasticid: this.talentpoolAndCandidateData.profileurlsarray,
        grabbedpage: this.currentPage,
      }
    } else {
      console.error('UNABLE TO FIND ELASTIC ID')
    }
    this.addToTalentpoolSpinner = true;

    this.personSearchService.addToTanentpool(talentpoolProfileAndData).subscribe((result: any) => {
      this.disablebutton = true;
      if (result.status == 'success') {
        this.modalService.dismissAll('isGrabbed')
        this.candidatetoBeGrabbed = [];
        this.candidateList = this.candidateList.map(x => ({ ...x, selected: false }));
        this.selected = false;

        this.getCandidateActivityInBulk(this.talentpoolAndCandidateData.profileurlsarray, 'talentpool')


        this.candidateList.forEach(item => {
          if (this.talentpoolAndCandidateData.profileurlsarray.includes(item.id)) {
              if(item.talentpoolcount){
                item.talentpoolcount = item.talentpoolcount + 1;
              }else{
                item.talentpoolcount = 1
              }
          }
      });

        // this.modalService.open(this.extractingProfile,  { windowClass: "modalExtract", centered: true })
        this.toastmessage('Profile added to talentpool', 'success')
      } else if (result.status == 'failure') {
        if (result.message == 'User not on paid plan') {
          this.modalService.dismissAll()
          this.modalService.open(this.premiumUserError, { windowClass: "modalExtract", centered: true })
        }
        else if (result.bulkextractioninprogress) {
          this.toastmessage('Profile extraction already in progress. Please try again after sometime', 'error')
        } else if (result.message == 'already-added') {
          this.modalService.dismissAll()
          this.toastmessage('Candidate has already been added to this talentpool', 'error')
        }
        else {
          this.toastmessage('Something went Wrong', 'error')
        }
      }
    }, () => {

    }, () => {
      this.addToTalentpoolSpinner = false;
    });
  }

  toastmessage(message, type) {
    if (type == 'success') {
      this.successMessage = message;
      setTimeout(() => this.successMessage = '', 5000);
    } else if (type == 'error') {
      this.errorMessage = message;
      setTimeout(() => this.errorMessage = '', 5000);
    }
  }


  talentPoolandCandidateDataEvent(event) {
    if(event.talentpoolname == '') {
      this.disablebutton = true;
      this.talentpoolAndCandidateData = null;
      return;
    }
    if (event) {
      this.disablebutton = false;
      this.talentpoolAndCandidateData = event
    }
  }

  sendEmailAndGrabCandidate() {
    this.profileurlsarray = []
    this.profileurlsarray = this.candidatetoBeGrabbed.map(x => x.idinindex)
    this.profileurlsarray = this.profileurlsarray.filter((item,
      index) => this.profileurlsarray.indexOf(item) === index);
      this.disablebutton = true;
    const modalRef = this.modalService.open(this.extractToTalentpool, { windowClass: "modalExtract", centered: true });
    modalRef.result.then((data) => {
      // on close
    },
      (error) => {
        if (error != 'isGrabbed') {
          this.modalDismissed = true;
        }
      });

  }

  // not in an indian format
  formatNumberToIndianFormat(number) {
    if (number) {
      const suffixes = ['', 'K+', 'M+', 'B+', 'T+']; // Add more suffixes as needed for larger numbers
      for (const suffix of suffixes) {
        if (Math.abs(number) < 1000) {
          return Math.floor(number) + suffix;
        }
        number /= 1000;
      }
      return Math.floor(number) + 'T';
    } else {
      return 0
    }
  }

  // Can't find usage here
  getLikelyToMoveInAggs() {
    Object.assign(this.requestObject, { 'resultsize': 1, 'aggregatetype': 'likelytomove' });
    delete this.requestObject['calledfrom'];
    delete this.requestObject['input'];
    delete this.requestObject['typeahead'];
    this.personSearchService.getTotalAggs(this.requestObject).subscribe(response => {
      if (response.status == 'success') {
        this.likelyToMoveIn = response.data && response.data.aggregations && response.data.aggregations.likelytomove && response.data.aggregations.likelytomove.filter(l => l.key == 1)[0] && response.data.aggregations.likelytomove.filter(l => l.key == 1)[0].doc_count || 0;
      }
    });
  }


  getGenderAggs() {
    Object.assign(this.requestObject, { 'resultsize': 1, 'aggregatetype': 'gender' });
    delete this.requestObject['calledfrom'];
    delete this.requestObject['input'];
    delete this.requestObject['typeahead'];
    this.personSearchService.getTotalAggs(this.requestObject).subscribe(response => {
      if (response.status == 'success') {
        const maleCount = response.data && response.data.aggregations && response.data.aggregations.gender && response.data.aggregations.gender.filter(g => g.key == 'male')[0] && response.data.aggregations.gender.filter(g => g.key == 'male')[0].doc_count || 0;
        const femaleCount = response.data && response.data.aggregations && response.data.aggregations.gender && response.data.aggregations.gender.filter(g => g.key == 'female')[0] && response.data.aggregations.gender.filter(g => g.key == 'female')[0].doc_count || 0;
        this.malePercent = maleCount ? ((maleCount / (maleCount + femaleCount)) * 100).toFixed(0) : 0;
        this.femalePercent = femaleCount ? ((femaleCount / (maleCount + femaleCount)) * 100).toFixed(0) : 0;
      }
    });
  }

  getContactsAvailability() {
    this.requestObject['aggregatetype'] = 'contactsavailability';
    delete this.requestObject['input'];
    delete this.requestObject['typeahead'];
    this.personSearchService.getTotalAggs(this.requestObject).subscribe(response => {
      if (response.status == 'success') {
        this.contactsAvailability = response.data && response.data.aggregations && response.data.aggregations.contactsavailability && response.data.aggregations.contactsavailability.doc_count;
      }
    });
  }

  private turnOnLoaders(excludeTotalCandidatesCountAvailable = true) {
    if (!excludeTotalCandidatesCountAvailable)
      this.totalCandidatesCountAvailable = false;
    this.likelyToMoveInCountAvailable = false;
    this.medianTenureInCountAvailable = false;
    this.genderDataAvailable = false;
    this.contactsAvailabilityCountAvailable = false;
    this.changedJobsCountAvailable = false;
  }

  getJobtitleReport() {
    this.requestObject['aggregatetype'] = 'jobtitle';
    delete this.requestObject['input'];
    delete this.requestObject['typeahead'];
    this.personSearchService.getTotalAggs(this.requestObject).subscribe(response => {
      if (response.status == 'success') {
        this.jobTitleTable = this.jobTitleStatus == 'Current or Past' ? new MatTableDataSource(response.data.aggregations.jobtitle) : this.jobTitleStatus == 'Current' ? new MatTableDataSource(response.data.aggregations.current_jobtitle) : new MatTableDataSource(response.data.aggregations.pastjobtitle);
      }
    });
  }


  getSkillsReport() {
    this.requestObject['aggregatetype'] = 'skills';
    delete this.requestObject['input'];
    delete this.requestObject['typeahead'];
    this.personSearchService.getTotalAggs(this.requestObject).subscribe(response => {
      if (response.status == 'success') {
        this.skillsTable = new MatTableDataSource(response.data.aggregations.skills);
      }
    });
  }

  getEducationReport() {
    this.requestObject['aggregatetype'] = 'education';
    delete this.requestObject['input'];
    delete this.requestObject['typeahead'];
    this.personSearchService.getTotalAggs(this.requestObject).subscribe(response => {
      if (response.status == 'success') {
        this.educationTable = new MatTableDataSource(response.data.aggregations.education);
      }
    });
  }


  getFieldOfStudyReport() {
    this.requestObject['aggregatetype'] = 'fieldofstudy';
    delete this.requestObject['input'];
    delete this.requestObject['typeahead'];
    this.personSearchService.getTotalAggs(this.requestObject).subscribe(response => {
      if (response.status == 'success') {
        this.fieldOfStudyTable = new MatTableDataSource(response.data.aggregations.fieldofstudy);
      }
    });
  }



  getLocationReport() {
    this.requestObject['aggregatetype'] = 'location';
    delete this.requestObject['input'];
    delete this.requestObject['typeahead'];
    this.personSearchService.getTotalAggs(this.requestObject).subscribe(response => {
      if (response.status == 'success') {
        this.topLocationsTable = new MatTableDataSource(response.data.aggregations.location);
      }

    });
  }

  private setMatrixStats(res: [any, any, any]) {
    let response = res.find(el => !!el?.data?.aggregations?.gender);
    const maleCount = response.data && response.data.aggregations && response.data.aggregations.gender && response.data.aggregations.gender.filter(g => g.key == 'male')[0] && response.data.aggregations.gender.filter(g => g.key == 'male')[0].doc_count || 0;
    const femaleCount = response.data && response.data.aggregations && response.data.aggregations.gender && response.data.aggregations.gender.filter(g => g.key == 'female')[0] && response.data.aggregations.gender.filter(g => g.key == 'female')[0].doc_count || 0;
    this.malePercent = maleCount ? ((maleCount / (maleCount + femaleCount)) * 100).toFixed(0) : 0;
    this.femalePercent = femaleCount ? ((femaleCount / (maleCount + femaleCount)) * 100).toFixed(0) : 0;

    // response = res.find(el => !!el.data.aggregations.likelytomove);
    // this.likelyToMoveIn = response.data && response.data.aggregations && response.data.aggregations.likelytomove && response.data.aggregations.likelytomove.filter(l => l.key == 1)[0] && response.data.aggregations.likelytomove.filter(l => l.key == 1)[0].doc_count || 0;

    response = res.find(el => !!el.data.aggregations.changedjobs);
    this.changedJobs = response.data && response.data.aggregations && response.data.aggregations.changedjobs && response.data.aggregations.changedjobs.doc_count;
    
    response = res.find(el => !!el.data.aggregations.total_tenure_median);
    this.totalMedianTanureCount = response.data && response.data.aggregations && response.data.aggregations.total_tenure_median && response.data.aggregations.total_tenure_median.value;

    this.ngZone.run(() => {
      this.setCountAvailableAll();
    })
  }

  setChangeJobStats(response){
    this.changedJobs = response.data && response.data.aggregations && response.data.aggregations.changedjobs && response.data.aggregations.changedjobs.doc_count;
    this.changedJobsCountAvailable = true;
  }

  getTableByStatus() {
    switch (this.jobTitleStatus) {
      case 'Current or Past':
        return 'jobtitle';
      case 'Past':
        return 'pastjobtitle'
      default:
        return 'current_jobtitle';
    }
  }

  /**
   * Check if current search (via historyid) is saved
   */
  getSavedSearchDetails() {
    this.isSearchSaved = false;
    this.personSearchService.getSaveSearchHistory(0, this.talentdiscoveryhistoryid).subscribe((res: any) => {
      if(res && res.status === 'success') {
        if(res.message && (Array.isArray(res.message) && res.message?.length)) {
          this.savedSearchDetails = res.message[0];
          this.savedSearchDetails && (this.isSearchSaved = true);
        }
        if(this.isInsightsActive == true) {
          const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
          //loadn[0].style.display = 'block'
        }
      }
    });
  }

  saveSearch() {
    const modalRef = this.modalService.open(SaveSearchModalComponent, { windowClass: "modalExtract", centered: true, keyboard: false, backdrop: 'static' });
    modalRef.componentInstance.talentdiscoveryhistoryid = this.talentdiscoveryhistoryid;
    this.savedSearchDetails && (modalRef.componentInstance.searchName = this.savedSearchDetails?.talentdiscoveryname);
    modalRef.result
      .then((message: any) => {
        if(message && message === 'Saved successfully') {
          this.isSearchSaved = true;
          this.successMessage = 'Search saved successfully';
        }
      })
      .catch((err: any) => {
        this.errorMessage = 'Something went wrong';
      })
      .finally(() => {
        this.getSavedSearchDetails();
        setTimeout(() => {
          this.successMessage = '';
          this.errorMessage = '';
        }, 5000);
      })
  }

 getCompanyInfo(type:string, data: any, event){

  let pastCompanyData = data

  this.currentCompanyInformation['name'] = pastCompanyData?.name
  this.currentCompanyInformation['industry'] = pastCompanyData?.industry
  this.currentCompanyInformation['linkedin_url'] = pastCompanyData?.linkedin_url
  this.currentCompanyInformation['location'] = pastCompanyData?.location?.name
  this.currentCompanyInformation['size'] = pastCompanyData?.size
  this.currentCompanyInformation['website'] = pastCompanyData?.website
  this.currentCompanyInformation['companylogo'] = pastCompanyData.companylogo
  this.currentCompanyInformation['tags'] = pastCompanyData.tags

}

openUrl(link, type) {
  if (type == 'website'){
    link = "https://www." + link;
  }
  window.open(link, "_blank")
}
//Add candidate to email campaign
  openAddToEmailCampaign(data){
    if(data && data.id){
      const candidateData = this.candidateList.filter(x=>x.id === data.id)
      this.campaignCandidatesArray = candidateData;
    }
    else{
      this.campaignCandidatesArray = this.candidatetoBeGrabbed;
    }
    const modalRef = this.modalService.open(this.addCandidateToEmailCampaign, { size: 'xs' as 'lg', centered: true, backdrop : 'static', keyboard : false });
  }


onClickMatrix(type){
  // If redirected from insights and gender was already selected we do not want it to be editable
  if ((type === "Male" || type === "Female") && this.isGenderSelectionDisabled) return;

  let event = {};
  let matrixType;
  if(type === 'likelytomovein' ){
    this.isLikelyToMoveInFilterSelected = !this.isLikelyToMoveInFilterSelected;
    this.candidateslikelytomove = this.isLikelyToMoveInFilterSelected ? 'Yes' : 'All'
    event = {
      "target":{
        "value":this.isLikelyToMoveInFilterSelected ? 'Yes' : 'All'
      }
    }
    matrixType = "likelytomovein";
  }
  else if(type?.trim()?.toLowerCase() === 'male'){
    this.isMaleMatrixSelected = !this.isMaleMatrixSelected;
    this.isFemaleMatrixSelected = false;
    event = {
      "target":{
        "value": this.isMaleMatrixSelected ? 'Male' : 'All'
      }
    };
    matrixType = "gender";
  }
  else if(type === 'Female'){
    this.isMaleMatrixSelected = false;
    this.isFemaleMatrixSelected = !this.isFemaleMatrixSelected;
    event = {
      "target":{
        "value": this.isFemaleMatrixSelected ? 'Female' : 'All'
      }
    };
    matrixType = "gender";
  }
  else if(type === 'changedJobs'){
    this.isChangedJobsSelected = !this.isChangedJobsSelected;
    this.changedJobStatus = this.isChangedJobsSelected ? 'yes' : 'all';
    event = {
      "target":{
        "value": this.changedJobStatus,
        "endDuration": this.changedJobDuration
      }
    };
    matrixType = "changedJobs";
  }
  this.statsMatrixHandlerService.emitMatrixSelectionObject(new MatrixFilter(matrixType, event));
}
  onTypeAheadSearchCampaign(event: any): void {
    const query = event.target.value;
    this.emailCampaignService.getCampaigns({campaign_name: query,  created_by: this.localstorageservice.getItem('userdata').userid, 'status[]': [1,2]}).subscribe((data) => {
      this.campaignList = data['data'];
    });
  }

changedJobAgg(event){
  if(this.isChangedJobsSelected){
    this.changedJobStatus = 'yes';
    event = {
      "target":{
        "value": this.changedJobStatus,
        "endDuration": parseInt(event?.target?.value)
      }
    };
    let matrixType = "changedJobs";
    this.statsMatrixHandlerService.emitMatrixSelectionObject(new MatrixFilter(matrixType, event));
  }
  else{

    this.changedJobDuration = parseInt(event?.target?.value);
    this.changedJobEndDuration = this.changedJobDuration;
    // this.changedJobStartDuration = 0;
    this.aggregationService.getChangedJobStats(this.changedJobStartDuration,this.changedJobEndDuration,'yes');
  }
}

  exportToPDF() {
    this.personSearchService.exportCandidateProfileToPDF({ elasticid: this.currentCandidate.id }).subscribe((res: any) => {
      if(res) {
        if(res.status === 'failure') {
          this.errorMessage = 'Error occured while exporting to PDF';
        } else {
          const blobFile = new Blob([res], { type: 'application/pdf' });
          const blobUrl = URL.createObjectURL(blobFile);
          const downloadLink = document.createElement("a");
          downloadLink.style.display = "none";
          document.body.appendChild(downloadLink);
          downloadLink.setAttribute("href", blobUrl);
          downloadLink.setAttribute("download", `${this.currentCandidate.full_name.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())}.pdf`);
          downloadLink.click();
          document.body.removeChild(downloadLink);
          this.successMessage = 'Exported to PDF successfully'
        }
        setTimeout(() => {
          this.successMessage = '';
          this.errorMessage = '';
        }, 5000);
      }
    });
  }

getsimilarcandidatetooltiptext() {
  this.generateAIMOdalLoader = false;
    if (this.isComingFromJD) {
      this.similarobject = { data: this.jdDataService.jdDataFromSession };
    }
      
    if (this.similarobject?.data?.jobtitle) {
      this.similarobject?.data?.jobtitle.forEach(jt => {
        jt.isMandatory ? this.mustHaveSimilarCandidate.push({ field: jt.key.replace(/\.searchastext/g, ''), tooltipText: "Priority Job Title", isMandatory: true }) : this.goodToHaveFilters.push({ field: jt.key.replace(/\.searchastext/g, ''), tooltipText: "Job Title", isMandatory: false });
      });
    }

    if (this.similarobject?.data?.jobindustryname) {
      this.similarobject?.data?.jobindustryname.forEach(ji => {
        ji.isMandatory ? this.mustHaveSimilarCandidate.push({ field: ji.key.replace(/\.searchastext/g, ''), tooltipText: "Priority Industry", isMandatory: true }) : this.goodToHaveFilters.push({ field: ji.key.replace(/\.searchastext/g, ''), tooltipText: "Industry", isMandatory: false });
      });
    }

    if (this.similarobject?.data?.jobcompanyname) {
      this.similarobject?.data?.jobcompanyname.forEach(jc => {
        jc.isMandatory ? this.mustHaveSimilarCandidate.push({ field: jc.key.replace(/\.searchastext/g, ''), tooltipText: "Priority Company", isMandatory: true }) : this.goodToHaveFilters.push({ field: jc.key.replace(/\.searchastext/g, ''), tooltipText: "Company", isMandatory: false });
      });
    }

    if (this.similarobject?.data?.companysize && Array.isArray(this.similarobject?.data?.companysize) && this.similarobject?.data?.companysize?.length && this.similarobject?.data?.companysize[0] != null) {
      this.similarobject?.data?.companysize.forEach(cs => {
        cs.isMandatory ? this.mustHaveSimilarCandidate.push({ field: cs.key.replace(/\.searchastext/g, ''), tooltipText: "Priority Company Size", isMandatory: true }) : this.goodToHaveFilters.push({ field: cs.key.replace(/\.searchastext/g, ''), tooltipText: "Company Size", isMandatory: false });
      });
    }

    // if (this.similarobject?.data?.fromYrsOfExperience) {
    //   this.goodToHaveFilters.push({ field: this.similarobject?.data?.fromYrsOfExperience, tooltipText: "Total Tenure" });
    // }

    // if (this.similarobject?.data?.toYrsOfExperinece) {
    //   this.goodToHaveFilters.push({ field: this.similarobject?.data?.toYrsOfExperinece, tooltipText: "Total Tenure" });
    // }

    if (this.similarobject?.data?.currentlocation && Array.isArray(this.similarobject?.data?.currentlocation) && this.similarobject?.data?.currentlocation?.length && this.similarobject?.data?.currentlocation[0] != null && this.similarobject?.data?.currentlocation[0] != '') {
      this.similarobject?.data?.currentlocation.forEach(cl => {
        cl.isMandatory ? this.mustHaveSimilarCandidate.push({ field: cl.key.replace(/\.searchastext/g, ''), tooltipText: "Priority Location", isMandatory: true }) : this.goodToHaveFilters.push({ field: cl.key.replace(/\.searchastext/g, ''), tooltipText: "Location", isMandatory: false });
      });
    }

    if (this.similarobject && this.similarobject.data && Array.isArray(this.similarobject?.data?.skills) && this.similarobject.data.skills.length && this.similarobject?.data?.skills[0] != null) {
      this.similarobject?.data?.skills.forEach(skill => {
        skill.isMandatory ? this.mustHaveSimilarCandidate.push({ field: skill.key.replace(/\.searchastext/g, ''), tooltipText: "Priority  Skill", isMandatory: true }) : this.goodToHaveFilters.push({ field: skill.key.replace(/\.searchastext/g, ''), tooltipText: "Skill", isMandatory: false });
      });
    }

    if (this.isComingFromJD && this.isArrayWithElements(this.similarobject?.data?.degrees)) {
      this.similarobject.data.degrees = this.similarobject.data.degrees.filter(Boolean);
      this.similarobject.data.degrees.forEach(degree => this.pushToAptFilterList(degree.key, "Degree", degree.isMandatory));
    }

    if (this.isComingFromJD && this.isArrayWithElements(this.similarobject?.data?.schools)) {
      this.similarobject.data.schools = this.similarobject.data.schools.filter(Boolean);
      this.similarobject.data.schools.forEach(school => this.pushToAptFilterList(school.key, "School", school.isMandatory));
    }

    if (this.isComingFromJD && this.isArrayWithElements(this.similarobject?.data?.fieldOfStudy)) {
      this.similarobject.data.fieldOfStudy = this.similarobject.data.fieldOfStudy.filter(Boolean);
      this.similarobject.data.fieldOfStudy.forEach(fos => this.pushToAptFilterList(fos.key, "Field of study", fos.isMandatory));
    }
    // if(this.jdDataService.isComingFromJobDescription) {
    //   const modalRef = this.modalService.open(GenAiJdSearchComponent,{windowClass: 'genAimodal',centered: true, backdrop: 'static', keyboard: false });
    //   modalRef.componentInstance.genAIEvent.subscribe(res=>{
    //     if(res.action == 'close') {
    //       this.generateAIMOdalLoader = true;
    //       if(this.showLoaderbeforeDataLoad == false){
    //         modalRef.dismiss();
    //       }
    //     }
    //   })
    // }
    this.modalFilters = this.mustHaveSimilarCandidate.concat(this.goodToHaveFilters);
  }

  private isArrayWithElements(arr) {
    return (
      !!arr && Array.isArray(arr) && arr.length > 0
    );
  }

  private pushToAptFilterList(value: string, tooltipText: string, isMandatory: boolean) {
    if (isMandatory) 
      this.mustHaveSimilarCandidate.push({ field: value.replace(/\.searchastext/g, ''), tooltipText: "Priority " + tooltipText, isMandatory: true });
    else
      this.goodToHaveFilters.push({ field: value.replace(/\.searchastext/g, ''), tooltipText, isMandatory: false });
  }

  isEmptyOrUndefined(object: any): boolean {
    return _.isEmpty(object);
  }


  cleanCompanyName(companyName: string): string {
    return companyName.replace(/_/g, ' ');
  }

  selectRegion(region) {
    this.searchHistoryRegion = null;
    this.showregion = region;
    this.localstorageservice.setItem('region', region)
    this.sessionStorageService.setItem("historyRegion", null)
    this.filterDataHandlerService.setUpdatedContinent(true)

    if(this.isInsightsActive){
      const extraInfo = {
         redirectSource: this.redirectSource,
         redirectData: this.redirectData,
      }

      const statusMap = {
        jobTitleStatus: this.jobTitleStatus,
        companyStatus: this.companyStatus,
        industryStatus: this.industryStatus,
        yearsOfExperienceType: this.yearsofexperience
      };
      this.aggregationService.getPersonSearchRecommendedCandidates(extraInfo)
    }else{
      this.getPersonSearchRecommendedCandidates()
    }
  }
insightsEventHandler(event) {
  const action = event.action;
  switch(action) {
    case 'redirect': {
      this.ngZone.run(()=> this.onTabChange('listing'));
      break;
    }
    case 'aidata': {
      this.insightsaidata = event.data;
      this.insightsSubject.next(this.insightsaidata);
      break;
    }
  }
}
  // Add this function to handle the selection from the typeahead
  onCampaignSelected(value): void {
    this.selectedCampaign = value;
    this.campaign_input.setValue(value.campaign_name);
  }

  async addToEmailCampaign() {
    this.campaign_input.markAllAsTouched();

    this.isLoadingEmailCampaignApi = true;
    let totalTarget = 0;
    let unsubscribedCandidateCount = 0;
    if (this.campaign_input.valid && this.selectedCampaign) {
      const campaign_id = this.selectedCampaign.campaign_id;
      let payloadArray = this.campaignCandidatesArray?.length && this.campaignCandidatesArray.map(x => {
        totalTarget++;
        if(x?.is_unsubscribed){
          unsubscribedCandidateCount++;
          return
        }
        return {
          firstname: x.first_name,
          target_name: x.full_name,
          target_id: null,
          target_meta: JSON.stringify({
            "candidatenumber": x.candidatenumber && x.candidatenumber.length ? x.candidatenumber : null,
            "elastic_id": x.id,
            "title": x.job_title,
          }),

          //elastic || else send 0
          target_email: x.existingContactDetails && x.existingContactDetails.length ?
            this.extractPreferredEmail(x.existingContactDetails) : null,
          is_active: true,
          created_on: new Date().toISOString(),
          updated_on: new Date().toISOString()
        };
      }).filter(Boolean);
      const updatedPayloadArray = (payloadArray?.length) ? payloadArray.filter(x => x) : [];
      this.emailFoundCount = 0;
      updatedPayloadArray.forEach(element => {
        if (element.target_email)
          this.emailFoundCount++;
      }
      );
      const payloadWithCandidateNumber = updatedPayloadArray.filter(
        (x) => JSON.parse(x.target_meta || '{}')?.candidatenumber
      );
      const payloadWithoutCandidateNumber = updatedPayloadArray.filter(
        (x) => !JSON.parse(x.target_meta || '{}')?.candidatenumber
      );
      let finalPayload = payloadWithCandidateNumber;
      if (
        payloadWithCandidateNumber &&
        payloadWithCandidateNumber.length > 0 &&
        payloadWithoutCandidateNumber &&
        payloadWithoutCandidateNumber.length === 0
      ) {
      } else if (
        payloadWithoutCandidateNumber &&
        payloadWithoutCandidateNumber.length > 0
      ) {
        const elasticid = payloadWithoutCandidateNumber.map(
          (x) => JSON.parse(x.target_meta).elastic_id
        );
        const res = await this.emailCampaignService.migrateCandidates({ elasticid }).toPromise();
        payloadWithoutCandidateNumber.forEach((x) => {
          const parsedElasticId = JSON.parse(x.target_meta).elastic_id;
          if (res && res.data && res.data.length) {
            res.data.map((item) => {
              if (item.elasticId === parsedElasticId) {
                let tempMeta = JSON.parse(x.target_meta);
                tempMeta.candidatenumber = item.candidatenumber;
                x.target_meta = JSON.stringify(tempMeta);
              }
              x.target_id = null;
            });
          }
        });
        finalPayload =  finalPayload.concat(payloadWithoutCandidateNumber);
      }
      finalPayload = finalPayload.filter(x=> (JSON.parse(x?.target_meta)?.candidatenumber));

      const elasticid = finalPayload.map(
        (x) => JSON.parse(x.target_meta).elastic_id
      );

      //If final payload has length 0, and we have list of unbubscribed candidates then show toast,
      // No candidades were added to email campaign
      if(unsubscribedCandidateCount > 0 && finalPayload.length === 0){
        this.closeActiveModal();
        this.toastmessage("Unsubscribed from Email Campaign", 'error');
        return;
      }

      finalPayload?.length > 0 && this.emailCampaignService.createTarget(campaign_id, finalPayload).subscribe((res: any) => {
        if (res.status == 'success') {
          this.isLoadingEmailCampaignApi = false;
          if (res.data && res.data.length) {
            this.getCandidateActivityInBulk(elasticid, 'email-campaign')
            this.toastmessage("Candidate added to email campaign successfully", 'success');
            this.closeActiveModal()
            if (this.emailFoundCount !== finalPayload.length) {

              // new payload for openDetail modal that contains mapping of candidate number elastic_id and campaign_targe_id for bulk reveal
              const bulkRevealPayLoad = {
                enrichedFrom: "person-search-listing",
                candidates: [],
                campaign_id: campaign_id
              }

              res.data.map((arr) => {
                if (!arr?.target_email) {
                  bulkRevealPayLoad.candidates.push(
                    {
                      elastic_id: JSON.parse(arr?.target_meta || '{}')?.elastic_id,
                      // candidatenumber: JSON.parse(arr?.target_meta || '{}')?.candidatenumber,
                      campaign_target_id: arr.campaign_target_id
                    }
                  );
                }
              })

              this.openDetailsModal(campaign_id, bulkRevealPayLoad, this.emailFoundCount, totalTarget, unsubscribedCandidateCount);
          }
          else {
            this.closeActiveModal()
            if(unsubscribedCandidateCount){
              this.toastmessage("Unsubscribed from Email Campaign", 'error');
            }
            else this.toastmessage("Candidate already present in selected campaign", 'error')
          }

          this.candidatetoBeGrabbed = [];
          this.campaignCandidatesArray = [];
          this.candidateList = this.candidateList.map(x => ({ ...x, selected: false }));
          this.selected = false;
        }
        else if (res.status == 'failure') {
          this.closeActiveModal()
          this.toastmessage("candidate addition failed", "error");
        }
      }
    });
    } else{
      this.isLoadingEmailCampaignApi = false;
    }
  }
  getContactDetails(candidateid, type) {
    return new Promise((resolve, reject) => {
      let data = {
        "usernumber": this.localstorageservice.getItem('usernumber'),
        "candidatenumber": candidateid,
      };

      this.candidateservice.getContactDetails(data).subscribe(
        (res: any) => {
          if (res.status === 'success') {
            let email = null;
            if(type=='FirstPersonal'){
              email = res.data.emails.find((x) => x.isprimary && x.contactdetailcategory=='personal')?.contactdetail;
              if(email==null)
                email = res.data.emails.find((x) => x.isprimary && x.contactdetailcategory=='professional')?.contactdetail;
            }
            else if(type=='FirstProfessional'){
              email = res.data.emails.find((x) => x.isprimary && x.contactdetailcategory=='professional')?.contactdetail;
              if(email==null)
                email = res.data.emails.find((x) => x.isprimary && x.contactdetailcategory=='personal')?.contactdetail;
            }
            else{
               email = res.data.emails.find((x) => x.isprimary && x.contactdetailcategory==type)?.contactdetail;
            }
            if (email) {
              resolve(email);
            } else {
              // reject("Primary email not found for the candidate.");
              resolve(null);
            }
          } else {
            reject("Error fetching contact details for the candidate.");
          }
        },
        (error) => {
          reject("An error occurred while fetching contact details.");
        }
      );
    });
  }
  
  openDetailsModal(campaign_id, payload, emailsFound, total_target, unsubscribedCandidateCount) {
    const modalRef = this.modalService.open(BulkRevealModalComponent, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.campaign_id = campaign_id;
    modalRef.componentInstance.payload = payload;
    modalRef.componentInstance.emailsFound = emailsFound;
    modalRef.componentInstance.campaignDetails = this.selectedCampaign;
    modalRef.componentInstance.total_target = total_target;
    modalRef.componentInstance.unsubscribedCandidateCount = unsubscribedCandidateCount;
    modalRef.componentInstance.calledFor = 'email-campaign';
  }

  closeActiveModal(){
    this.campaign_input.markAsUntouched();
    this.campaign_input.markAsPristine();
    this.campaign_input.reset();
    this.modalService.dismissAll()
  }
  
  getEmailPref(data){
    if(data==1){
      return 'personal';
    }
    else if(data==2){
      return 'professional';
    }
    else if(data==3){
      return 'FirstPersonal';
    }
    else{
      return 'FirstProfessional';
    }
  }

  extractPreferredEmail(details){
    if(this.selectedCampaign['email_pref']==1 || this.selectedCampaign['email_pref'] == 2){
      let email = null;
      if(details.filter(x=>x.type=='email' && x.contactdetailcategory==this.getEmailPref(this.selectedCampaign['email_pref'])).length){
        email = details.find(x=>x.type=='email' && x.contactdetailcategory==this.getEmailPref(this.selectedCampaign['email_pref']) && x.isprimary)?.contactdetail
        if(!email) email = details.find(x=>x.type=='email' && x.contactdetailcategory==this.getEmailPref(this.selectedCampaign['email_pref']))?.contactdetail 
      }
      return email || null;
    }
    else if(this.selectedCampaign['email_pref']==3){
      let email = null;
      if(details.filter(x=>x.type=='email' && x.contactdetailcategory=='personal').length){
        email = details.find(x=>x.type=='email' && x.contactdetailcategory=='personal' && x.isprimary)?.contactdetail;
        if(!email) email = details.find(x=>x.type=='email' && x.contactdetailcategory=='personal')?.contactdetail;
      }
      else if( !email && details.filter(x=>x.type=='email' && x.contactdetailcategory=='professional').length){
        email = details.find(x=>x.type=='email' && x.contactdetailcategory=='professional' && x.isprimary)?.contactdetail
        if(!email) email = details.find(x=>x.type=='email' && x.contactdetailcategory=='professional')?.contactdetail
      }
      return email || null;
    }
    else {
      let email = null
      if(details.filter(x=>x.type=='email' && x.contactdetailcategory=='professional').length){
        email = details.find(x=>x.type=='email' && x.contactdetailcategory=='professional' && x.isprimary)?.contactdetail;
        if(!email) email = details.find(x=>x.type=='email' && x.contactdetailcategory=='professional')?.contactdetail;
      }
      else if(!email && details.filter(x=>x.type=='email' && x.contactdetailcategory=='personal' && x.isprimary)?.length){
        email = details.find(x=>x.type=='email' && x.contactdetailcategory=='personal' && x.isprimary)?.contactdetail;
        if(!email) email = details.find(x=>x.type=='email' && x.contactdetailcategory=='personal').contactdetail;
      }
      return email || null;
    }
  }

  getLastActivity(elastic_id){
    if(elastic_id && Array.isArray(elastic_id) && elastic_id.length){
      elastic_id = elastic_id[0]
    }

    let currentIndex = this.candidateList.findIndex(x => x.idinindex === elastic_id)
    this.personSearchService.getLastCandidateActivity(elastic_id).subscribe((result: any) => {
      if(result && result.status == 'success'){
        this.candidateList[currentIndex]['lastcandidateactivity'] = result.message
      }
    });
  }

  refreshCurrentView($event){
    const elastic_id = $event && $event.id ? $event.id : null
    if(elastic_id != null){
      this.getLastActivity(elastic_id)
    }
  }


  getCandidateActivityInBulk(elastic_id, type){
    this.personSearchService.getCandidateActivityInBulk(elastic_id).subscribe((result: any) => {
      if(result && result.status == "success"){
        const bulkCandidateActivity = result.message
        this.candidateList.forEach(candidate => {
         let availableData = bulkCandidateActivity.find(y => y.elastic_id == candidate.idinindex)
         if(availableData){
          candidate['lastcandidateactivity'] = [availableData]
           if(type === 'email-campaign'){
            if( candidate['emailcampaigncount'] &&  candidate['emailcampaigncount'] >= 1){
              candidate['emailcampaigncount'] = candidate['emailcampaigncount'] + 1
            }else{
              candidate['emailcampaigncount'] = 1;
            }
          }
          }
        })
      }
    });
  }



  autoSearch(query: string) {
    this.searchKeyword = query;
    this.search();
  }

  openaiLoading({ state, count }) {
    this.isOpenAILoading = state;
    this.showOpenAISuggestions = count;
  }

  aiChipUpdate(aiSelection: SuggestedTitle[]) {
    this.aiSuggestion = aiSelection;
  }

  updateChipSelection(chip: { suggestedTitle: SuggestedTitle, [key: string]: any }[]) {
    this.updateChips.emit(chip.map(c => c.suggestedTitle));
  }

  insightsHandler(event) {
    this.insightsaidata = event.insights;
    this.insightsSubject.next(this.insightsaidata);
    //console.log("eventdata",event);
  }

  editSimilarCandidateFilters(firstLoad = false) {
    this.personSearchService.passsimilarcandidatesdata({
      ...this.similarobject,
      calledfrom: this.isComingFromJD ? GeneralConstants.REDIRECT_SOURCES.JOB_DESCRIPTION : 'edit-similar-candidate'
    });
    const modalRef = this.modalService.open(SimilarCandidateFilterComponent, { size: 'xl', windowClass: 'modal-size',centered: true, backdrop: 'static', keyboard: false });
    const modalInstance: SimilarCandidateFilterComponent = modalRef.componentInstance;
    modalInstance.type = "edit";
    
    modalRef.result.then((res) => {
      if (res?.action === 'submit' && this.isComingFromJD) {
        this.personSearchService.passsimilarcandidatesdata(res);
        const uniqueHash = this.route.snapshot.queryParamMap.get(GeneralConstants.LS_KEYS.UNIQUE_HASH);
        const similarObject = res?.data ? res.data : new SimilarCandidateDetails();
        this.jdDataService.setSessionData(uniqueHash, similarObject);
        this.similarobject = res;
        this.resetMustAndGoodFilters();
        this.jdDataService.jdFilterUpdateEventEmit();
      } else if(res.action == 'submit') {
        this.personSearchService.passsimilarcandidatesdata(res);
        this.localstorageservice.setItem('similar-candidates-additional-filters', JSON.stringify(res));
        this.similarobject = res;
        this.resetMustAndGoodFilters();
      } else if (res.action === 'close' && firstLoad) {
        this.location.back();
      }
      modalRef.dismiss();
    });
  }

  private resetMustAndGoodFilters() {
    this.mustHaveSimilarCandidate = [];
    this.goodToHaveFilters = [];
    this.getsimilarcandidatetooltiptext();
    this.setPage(1);
  }

  private getSafeKey(str: string): string {
    return str.toLowerCase().replace(/[^a-zA-Z0-9]/g, '');
  }
}

